(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-product-product-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-product-product-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-product-product-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-product-product-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-product-product-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-product-product-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-product-product-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-product-product-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-product-product-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-product-product-domain'.");
    }
    root['boislocal-platform-platform-s2-product-product-domain'] = factory(typeof this['boislocal-platform-platform-s2-product-product-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-product-product-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var Long = kotlin_kotlin.$_$.ed;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var $serializer_init_$Create$ = kotlin_org_boislocal_commons_domain.$_$.a;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var hashCode = kotlin_kotlin.$_$.j9;
  var equals = kotlin_kotlin.$_$.c9;
  var $serializer_getInstance = kotlin_org_boislocal_commons_domain.$_$.k;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var getNumberHashCode = kotlin_kotlin.$_$.g9;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var $serializer_getInstance_0 = kotlin_org_boislocal_commons_domain.$_$.j;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var toString = kotlin_kotlin.$_$.le;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(ProductState, 'ProductState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTransformationDateChangeCommandDTO, 'ProductTransformationDateChangeCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductTransformationDateChangedEventDTO, 'ProductTransformationDateChangedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(ProductTransformationDateChangeCommand, 'ProductTransformationDateChangeCommand', classMeta, VOID, [ProductTransformationDateChangeCommandDTO]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTransformationDateChangedEvent, 'ProductTransformationDateChangedEvent', classMeta, VOID, [ProductTransformationDateChangedEventDTO], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(ProductCreateCommandDTO, 'ProductCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(ProductCreatedEventDTO, 'ProductCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductCreateCommand, 'ProductCreateCommand', classMeta, VOID, [ProductCreateCommandDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductCreatedEvent, 'ProductCreatedEvent', classMeta, VOID, [ProductCreatedEventDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(ProductDeleteCommandDTO, 'ProductDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductDeletedEventDTO, 'ProductDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductDeleteCommand, 'ProductDeleteCommand', classMeta, VOID, [ProductDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductDeletedEvent, 'ProductDeletedEvent', classMeta, VOID, [ProductDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(ProductFinishCommandDTO, 'ProductFinishCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductFinishedEventDTO, 'ProductFinishedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductFinishCommand, 'ProductFinishCommand', classMeta, VOID, [ProductFinishCommandDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductFinishedEvent, 'ProductFinishedEvent', classMeta, VOID, [ProductFinishedEventDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(ProductImportCommandDTO, 'ProductImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(ProductImportedEventDTO, 'ProductImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductImportCommand, 'ProductImportCommand', classMeta, VOID, [ProductImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductImportedEvent, 'ProductImportedEvent', classMeta, VOID, [ProductImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor(ProductInitLinkedCommandDTO, 'ProductInitLinkedCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(ProductInitializedLinkedEventDTO, 'ProductInitializedLinkedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor($serializer_9, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductInitLinkedCommand, 'ProductInitLinkedCommand', classMeta, VOID, [ProductInitLinkedCommandDTO], VOID, VOID, {0: $serializer_getInstance_11});
  setMetadataFor(ProductRenameCommandDTO, 'ProductRenameCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductRenamedEventDTO, 'ProductRenamedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(ProductRenameCommand, 'ProductRenameCommand', classMeta, VOID, [ProductRenameCommandDTO]);
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor($serializer_10, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductRenamedEvent, 'ProductRenamedEvent', classMeta, VOID, [ProductRenamedEventDTO], VOID, VOID, {0: $serializer_getInstance_12});
  setMetadataFor(ProductTransformationActorDefineCommandDTO, 'ProductTransformationActorDefineCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductTransformationActorDefinedEventDTO, 'ProductTransformationActorDefinedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(ProductTransformationActorDefineCommand, 'ProductTransformationActorDefineCommand', classMeta, VOID, [ProductTransformationActorDefineCommandDTO]);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor($serializer_11, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTransformationActorDefinedEvent, 'ProductTransformationActorDefinedEvent', classMeta, VOID, [ProductTransformationActorDefinedEventDTO], VOID, VOID, {0: $serializer_getInstance_13});
  setMetadataFor(ProductUnlockCommandDTO, 'ProductUnlockCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductUnlockedEventDTO, 'ProductUnlockedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor($serializer_12, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductUnlockCommand, 'ProductUnlockCommand', classMeta, VOID, [ProductUnlockCommandDTO], VOID, VOID, {0: $serializer_getInstance_14});
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor($serializer_13, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductUnlockedEvent, 'ProductUnlockedEvent', classMeta, VOID, [ProductUnlockedEventDTO], VOID, VOID, {0: $serializer_getInstance_15});
  setMetadataFor(ProductUpdateCommandDTO, 'ProductUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductUpdatedEventDTO, 'ProductUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(ProductUpdateCommand, 'ProductUpdateCommand', classMeta, VOID, [ProductUpdateCommandDTO]);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor($serializer_14, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductUpdatedEvent, 'ProductUpdatedEvent', classMeta, VOID, [ProductUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_16});
  setMetadataFor(DestinationModelDTO, 'DestinationModelDTO', interfaceMeta);
  setMetadataFor(EndProductModelDTO, 'EndProductModelDTO', interfaceMeta);
  setMetadataFor(Companion_16, 'Companion', objectMeta);
  setMetadataFor($serializer_15, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(DestinationModel, 'DestinationModel', classMeta, VOID, [DestinationModelDTO], VOID, VOID, {0: $serializer_getInstance_17});
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  setMetadataFor($serializer_16, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(EndProductModel, 'EndProductModel', classMeta, VOID, [EndProductModelDTO], VOID, VOID, {0: $serializer_getInstance_18});
  setMetadataFor(OriginModelDTO, 'OriginModelDTO', interfaceMeta);
  setMetadataFor(OriginZoneModelDTO, 'OriginZoneModelDTO', interfaceMeta);
  setMetadataFor(Companion_18, 'Companion', objectMeta);
  setMetadataFor($serializer_17, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OriginModel, 'OriginModel', classMeta, VOID, [OriginModelDTO], VOID, VOID, {0: $serializer_getInstance_19});
  setMetadataFor(Companion_19, 'Companion', objectMeta);
  setMetadataFor($serializer_18, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OriginZoneModel, 'OriginZoneModel', classMeta, VOID, [OriginZoneModelDTO], VOID, VOID, {0: $serializer_getInstance_20});
  setMetadataFor(ProductMetricsDTO, 'ProductMetricsDTO', interfaceMeta);
  setMetadataFor(Companion_20, 'Companion', objectMeta);
  setMetadataFor($serializer_19, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductMetrics, 'ProductMetrics', classMeta, VOID, [ProductMetricsDTO], VOID, VOID, {0: $serializer_getInstance_21});
  setMetadataFor(ProductModelDTO, 'ProductModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_21, 'Companion', objectMeta);
  setMetadataFor($serializer_20, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductModel, 'ProductModel', classMeta, VOID, [ProductModelDTO], VOID, VOID, {0: $serializer_getInstance_22});
  setMetadataFor(ProductRefDTO, 'ProductRefDTO', interfaceMeta);
  setMetadataFor(SourceModelDTO, 'SourceModelDTO', interfaceMeta);
  setMetadataFor(RawProductModelDTO, 'RawProductModelDTO', interfaceMeta);
  setMetadataFor(Companion_22, 'Companion', objectMeta);
  setMetadataFor($serializer_21, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(SourceModel, 'SourceModel', classMeta, VOID, [SourceModelDTO], VOID, VOID, {0: $serializer_getInstance_23});
  setMetadataFor(Companion_23, 'Companion', objectMeta);
  setMetadataFor($serializer_22, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RawProductModel, 'RawProductModel', classMeta, VOID, [RawProductModelDTO], VOID, VOID, {0: $serializer_getInstance_24});
  setMetadataFor(TransformationModelDTO, 'TransformationModelDTO', interfaceMeta);
  setMetadataFor($serializer_23, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(TransformationModel, 'TransformationModel', classMeta, VOID, [TransformationModelDTO], VOID, VOID, {0: $serializer_getInstance_25});
  setMetadataFor(ProductModelAllQueryDTO, 'ProductModelAllQueryDTO', interfaceMeta);
  setMetadataFor(ProductModelAllResponseDTO, 'ProductModelAllResponseDTO', interfaceMeta);
  setMetadataFor(ProductModelGetQueryDTO, 'ProductModelGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(ProductModelGetResponseDTO, 'ProductModelGetResponseDTO', interfaceMeta);
  setMetadataFor(ProductPageQueryFiltersDTO, 'ProductPageQueryFiltersDTO', interfaceMeta);
  setMetadataFor(ProductModelPageQueryDTO, 'ProductModelPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(ProductPageResponseDTO, 'ProductPageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.d2q_1.f2();
  }
  function ProductState$Companion$_anonymous__uw9agd() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.product.domain.automate.ProductState', values());
  }
  var ProductState_Exists_instance;
  var ProductState_Deleted_instance;
  var ProductState_Finished_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d2q_1 = lazy(tmp_0, ProductState$Companion$_anonymous__uw9agd);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    ProductState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [ProductState_Exists_getInstance(), ProductState_Deleted_getInstance(), ProductState_Finished_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return ProductState_Exists_getInstance();
      case 'Deleted':
        return ProductState_Deleted_getInstance();
      case 'Finished':
        return ProductState_Finished_getInstance();
      default:
        ProductState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProductState_entriesInitialized;
  function ProductState_initEntries() {
    if (ProductState_entriesInitialized)
      return Unit_instance;
    ProductState_entriesInitialized = true;
    ProductState_Exists_instance = new ProductState('Exists', 0, 0);
    ProductState_Deleted_instance = new ProductState('Deleted', 1, 1);
    ProductState_Finished_instance = new ProductState('Finished', 2, 2);
    Companion_getInstance();
  }
  function ProductState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.g2q_1 = position;
  }
  protoOf(ProductState).y2c = function (_set____db54di) {
    this.g2q_1 = _set____db54di;
  };
  protoOf(ProductState).jr = function () {
    return this.g2q_1;
  };
  function S2$productAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'Product';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = ProductState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(ProductImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(ProductImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = ProductState_Deleted_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(ProductImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(ProductImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_1 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    builder_1.o27_1 = ProductState_Finished_getInstance();
    builder_1.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_1.m27_1;
    var tmp_7 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_8 = toValue(builder_1.c24());
    var tmp_9 = toValue_0(builder_1.d24());
    var tmp_10 = toValue_1(getKClass(ProductImportCommand));
    var tmp1_elvis_lhs_1 = builder_1.q27_1;
    var this_2 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(ProductImportedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_2);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_2 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    builder_2.o27_1 = ProductState_Exists_getInstance();
    builder_2.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_2 = builder_2.m27_1;
    var tmp_11 = tmp0_safe_receiver_2 == null ? null : toValue(tmp0_safe_receiver_2);
    var tmp_12 = toValue(builder_2.c24());
    var tmp_13 = toValue_0(builder_2.d24());
    var tmp_14 = toValue_1(getKClass(ProductCreateCommand));
    var tmp1_elvis_lhs_2 = builder_2.q27_1;
    var this_3 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp1_elvis_lhs_2 == null ? getKClass(ProductCreatedEvent) : tmp1_elvis_lhs_2));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_3);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_3 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_4 = builder_3.r27_1;
    var element = ProductState_Exists_getInstance();
    this_4.r(element);
    builder_3.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_5 = builder_3.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator = this_5.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_15 = toValue(item);
      var tmp_16 = toValue(item);
      var tmp_17 = toValue_0(builder_3.d24());
      var tmp_18 = toValue_1(getKClass(ProductRenameCommand));
      var tmp0_elvis_lhs = builder_3.t27_1;
      var tmp$ret$8 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp0_elvis_lhs == null ? getKClass(ProductRenamedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$8);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_4 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_6 = builder_4.r27_1;
    var element_1 = ProductState_Exists_getInstance();
    this_6.r(element_1);
    builder_4.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_7 = builder_4.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_7, 10));
    var tmp0_iterator_1 = this_7.u();
    while (tmp0_iterator_1.v()) {
      var item_0 = tmp0_iterator_1.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_19 = toValue(item_0);
      var tmp_20 = toValue(item_0);
      var tmp_21 = toValue_0(builder_4.d24());
      var tmp_22 = toValue_1(getKClass(ProductUpdateCommand));
      var tmp0_elvis_lhs_0 = builder_4.t27_1;
      var tmp$ret$12 = new S2Transition(tmp_19, tmp_20, tmp_21, tmp_22, toValue_1(tmp0_elvis_lhs_0 == null ? getKClass(ProductUpdatedEvent) : tmp0_elvis_lhs_0));
      destination_0.r(tmp$ret$12);
    }
    var tmp3_forEach_receiver_0 = $this$s2Sourcing.l27_1;
    var tmp0_iterator_2 = destination_0.u();
    while (tmp0_iterator_2.v()) {
      var element_2 = tmp0_iterator_2.w();
      invoke$add_0(tmp3_forEach_receiver_0, element_2);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_5 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_8 = builder_5.r27_1;
    var element_3 = ProductState_Exists_getInstance();
    this_8.r(element_3);
    builder_5.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_9 = builder_5.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_9, 10));
    var tmp0_iterator_3 = this_9.u();
    while (tmp0_iterator_3.v()) {
      var item_1 = tmp0_iterator_3.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_23 = toValue(item_1);
      var tmp_24 = toValue(item_1);
      var tmp_25 = toValue_0(builder_5.d24());
      var tmp_26 = toValue_1(getKClass(ProductTransformationDateChangeCommand));
      var tmp0_elvis_lhs_1 = builder_5.t27_1;
      var tmp$ret$16 = new S2Transition(tmp_23, tmp_24, tmp_25, tmp_26, toValue_1(tmp0_elvis_lhs_1 == null ? getKClass(ProductTransformationDateChangedEvent) : tmp0_elvis_lhs_1));
      destination_1.r(tmp$ret$16);
    }
    var tmp3_forEach_receiver_1 = $this$s2Sourcing.l27_1;
    var tmp0_iterator_4 = destination_1.u();
    while (tmp0_iterator_4.v()) {
      var element_4 = tmp0_iterator_4.w();
      invoke$add_1(tmp3_forEach_receiver_1, element_4);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_6 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_10 = builder_6.r27_1;
    var element_5 = ProductState_Exists_getInstance();
    this_10.r(element_5);
    builder_6.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_11 = builder_6.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_11, 10));
    var tmp0_iterator_5 = this_11.u();
    while (tmp0_iterator_5.v()) {
      var item_2 = tmp0_iterator_5.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_27 = toValue(item_2);
      var tmp_28 = toValue(item_2);
      var tmp_29 = toValue_0(builder_6.d24());
      var tmp_30 = toValue_1(getKClass(ProductTransformationActorDefineCommand));
      var tmp0_elvis_lhs_2 = builder_6.t27_1;
      var tmp$ret$20 = new S2Transition(tmp_27, tmp_28, tmp_29, tmp_30, toValue_1(tmp0_elvis_lhs_2 == null ? getKClass(ProductTransformationActorDefinedEvent) : tmp0_elvis_lhs_2));
      destination_2.r(tmp$ret$20);
    }
    var tmp3_forEach_receiver_2 = $this$s2Sourcing.l27_1;
    var tmp0_iterator_6 = destination_2.u();
    while (tmp0_iterator_6.v()) {
      var element_6 = tmp0_iterator_6.w();
      invoke$add_2(tmp3_forEach_receiver_2, element_6);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_7 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    builder_7.m27_1 = ProductState_Exists_getInstance();
    builder_7.o27_1 = ProductState_Deleted_getInstance();
    builder_7.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_3 = builder_7.m27_1;
    var tmp_31 = tmp0_safe_receiver_3 == null ? null : toValue(tmp0_safe_receiver_3);
    var tmp_32 = toValue(builder_7.c24());
    var tmp_33 = toValue_0(builder_7.d24());
    var tmp_34 = toValue_1(getKClass(ProductDeleteCommand));
    var tmp1_elvis_lhs_3 = builder_7.q27_1;
    var this_12 = new S2Transition(tmp_31, tmp_32, tmp_33, tmp_34, toValue_1(tmp1_elvis_lhs_3 == null ? getKClass(ProductDeletedEvent) : tmp1_elvis_lhs_3));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_12);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_8 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    builder_8.m27_1 = ProductState_Exists_getInstance();
    builder_8.o27_1 = ProductState_Finished_getInstance();
    builder_8.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_4 = builder_8.m27_1;
    var tmp_35 = tmp0_safe_receiver_4 == null ? null : toValue(tmp0_safe_receiver_4);
    var tmp_36 = toValue(builder_8.c24());
    var tmp_37 = toValue_0(builder_8.d24());
    var tmp_38 = toValue_1(getKClass(ProductFinishCommand));
    var tmp1_elvis_lhs_4 = builder_8.q27_1;
    var this_13 = new S2Transition(tmp_35, tmp_36, tmp_37, tmp_38, toValue_1(tmp1_elvis_lhs_4 == null ? getKClass(ProductFinishedEvent) : tmp1_elvis_lhs_4));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_13);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_9 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.product.domain.automate.S2.productAutomate.<anonymous>.<anonymous>' call
    builder_9.m27_1 = ProductState_Finished_getInstance();
    builder_9.o27_1 = ProductState_Exists_getInstance();
    builder_9.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_5 = builder_9.m27_1;
    var tmp_39 = tmp0_safe_receiver_5 == null ? null : toValue(tmp0_safe_receiver_5);
    var tmp_40 = toValue(builder_9.c24());
    var tmp_41 = toValue_0(builder_9.d24());
    var tmp_42 = toValue_1(getKClass(ProductUnlockCommand));
    var tmp1_elvis_lhs_5 = builder_9.q27_1;
    var this_14 = new S2Transition(tmp_39, tmp_40, tmp_41, tmp_42, toValue_1(tmp1_elvis_lhs_5 == null ? getKClass(ProductUnlockedEvent) : tmp1_elvis_lhs_5));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_14);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function invoke$add_0(receiver, p0) {
    receiver.r(p0);
  }
  function invoke$add_1(receiver, p0) {
    receiver.r(p0);
  }
  function invoke$add_2(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.h2q_1 = s2Sourcing(S2$productAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.j2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.j2q_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.j2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).k2q = function (encoder, value) {
    var tmp0_desc = this.j2q_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.k2q(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_1() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_1().j2q_1);
    }
    $this.i2q_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.i2q_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.i2q_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function ProductState_Exists_getInstance() {
    ProductState_initEntries();
    return ProductState_Exists_instance;
  }
  function ProductState_Deleted_getInstance() {
    ProductState_initEntries();
    return ProductState_Deleted_instance;
  }
  function ProductState_Finished_getInstance() {
    ProductState_initEntries();
    return ProductState_Finished_instance;
  }
  function ProductTransformationDateChangeCommandDTO() {
  }
  function ProductTransformationDateChangedEventDTO() {
  }
  function ProductTransformationDateChangeCommand(id, date) {
    this.m2q_1 = id;
    this.n2q_1 = date;
  }
  protoOf(ProductTransformationDateChangeCommand).k1y = function () {
    return this.m2q_1;
  };
  protoOf(ProductTransformationDateChangeCommand).x25 = function () {
    return this.n2q_1;
  };
  protoOf(ProductTransformationDateChangeCommand).toString = function () {
    return 'ProductTransformationDateChangeCommand(id=' + this.m2q_1 + ', date=' + this.n2q_1.toString() + ')';
  };
  protoOf(ProductTransformationDateChangeCommand).hashCode = function () {
    var result = getStringHashCode(this.m2q_1);
    result = imul(result, 31) + this.n2q_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductTransformationDateChangeCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTransformationDateChangeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTransformationDateChangeCommand ? other : THROW_CCE();
    if (!(this.m2q_1 === tmp0_other_with_cast.m2q_1))
      return false;
    if (!this.n2q_1.equals(tmp0_other_with_cast.n2q_1))
      return false;
    return true;
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductTransformationDateChangedEvent', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('transformationDate', false);
    tmp0_serialDesc.ht('time', false);
    this.o2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.o2q_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.o2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.am(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.am(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return ProductTransformationDateChangedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_0).p2q = function (encoder, value) {
    var tmp0_desc = this.o2q_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.q2q_1);
    tmp1_output.fn(tmp0_desc, 1, value.r2q_1);
    tmp1_output.fn(tmp0_desc, 2, value.s2q_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.p2q(encoder, value instanceof ProductTransformationDateChangedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_2() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function ProductTransformationDateChangedEvent_init_$Init$(seen1, id, transformationDate, time, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_2().o2q_1);
    }
    $this.q2q_1 = id;
    $this.r2q_1 = transformationDate;
    $this.s2q_1 = time;
    return $this;
  }
  function ProductTransformationDateChangedEvent_init_$Create$(seen1, id, transformationDate, time, serializationConstructorMarker) {
    return ProductTransformationDateChangedEvent_init_$Init$(seen1, id, transformationDate, time, serializationConstructorMarker, objectCreate(protoOf(ProductTransformationDateChangedEvent)));
  }
  function ProductTransformationDateChangedEvent(id, transformationDate, time) {
    this.q2q_1 = id;
    this.r2q_1 = transformationDate;
    this.s2q_1 = time;
  }
  protoOf(ProductTransformationDateChangedEvent).k1y = function () {
    return this.q2q_1;
  };
  protoOf(ProductTransformationDateChangedEvent).l2q = function () {
    return this.r2q_1;
  };
  protoOf(ProductTransformationDateChangedEvent).g2c = function () {
    return this.s2q_1;
  };
  protoOf(ProductTransformationDateChangedEvent).s2Id = function () {
    return this.q2q_1;
  };
  protoOf(ProductTransformationDateChangedEvent).toString = function () {
    return 'ProductTransformationDateChangedEvent(id=' + this.q2q_1 + ', transformationDate=' + this.r2q_1.toString() + ', time=' + this.s2q_1.toString() + ')';
  };
  protoOf(ProductTransformationDateChangedEvent).hashCode = function () {
    var result = getStringHashCode(this.q2q_1);
    result = imul(result, 31) + this.r2q_1.hashCode() | 0;
    result = imul(result, 31) + this.s2q_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductTransformationDateChangedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTransformationDateChangedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTransformationDateChangedEvent ? other : THROW_CCE();
    if (!(this.q2q_1 === tmp0_other_with_cast.q2q_1))
      return false;
    if (!this.r2q_1.equals(tmp0_other_with_cast.r2q_1))
      return false;
    if (!this.s2q_1.equals(tmp0_other_with_cast.s2q_1))
      return false;
    return true;
  };
  function ProductCreateCommandDTO() {
  }
  function ProductCreatedEventDTO() {
  }
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2q_1 = [$serializer_init_$Create$(StringSerializer_getInstance()), $serializer_init_$Create$(StringSerializer_getInstance()), $serializer_init_$Create$(StringSerializer_getInstance())];
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.command.ProductCreateCommand', this, 3);
    tmp0_serialDesc.ht('actor', false);
    tmp0_serialDesc.ht('productType', false);
    tmp0_serialDesc.ht('ouvrage', false);
    this.a2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.a2r_1;
  };
  protoOf($serializer_1).wt = function () {
    var tmp0_cached = Companion_getInstance_2().z2q_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], get_nullable(tmp0_cached[2])];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.a2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    var tmp8_cached = Companion_getInstance_2().z2q_1;
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.gm(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.gm(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.gm(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.gm(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return ProductCreateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_1).b2r = function (encoder, value) {
    var tmp0_desc = this.a2r_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().z2q_1;
    tmp1_output.ln(tmp0_desc, 0, tmp2_cached[0], value.c2r_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.d2r_1);
    tmp1_output.nn(tmp0_desc, 2, tmp2_cached[2], value.e2r_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.b2r(encoder, value instanceof ProductCreateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_3() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function ProductCreateCommand_init_$Init$(seen1, actor, productType, ouvrage, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_3().a2r_1);
    }
    $this.c2r_1 = actor;
    $this.d2r_1 = productType;
    $this.e2r_1 = ouvrage;
    return $this;
  }
  function ProductCreateCommand_init_$Create$(seen1, actor, productType, ouvrage, serializationConstructorMarker) {
    return ProductCreateCommand_init_$Init$(seen1, actor, productType, ouvrage, serializationConstructorMarker, objectCreate(protoOf(ProductCreateCommand)));
  }
  function ProductCreateCommand(actor, productType, ouvrage) {
    Companion_getInstance_2();
    this.c2r_1 = actor;
    this.d2r_1 = productType;
    this.e2r_1 = ouvrage;
  }
  protoOf(ProductCreateCommand).t2q = function () {
    return this.c2r_1;
  };
  protoOf(ProductCreateCommand).u2q = function () {
    return this.d2r_1;
  };
  protoOf(ProductCreateCommand).v2q = function () {
    return this.e2r_1;
  };
  protoOf(ProductCreateCommand).toString = function () {
    return 'ProductCreateCommand(actor=' + this.c2r_1 + ', productType=' + this.d2r_1 + ', ouvrage=' + this.e2r_1 + ')';
  };
  protoOf(ProductCreateCommand).hashCode = function () {
    var result = hashCode(this.c2r_1);
    result = imul(result, 31) + hashCode(this.d2r_1) | 0;
    result = imul(result, 31) + (this.e2r_1 == null ? 0 : hashCode(this.e2r_1)) | 0;
    return result;
  };
  protoOf(ProductCreateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductCreateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductCreateCommand ? other : THROW_CCE();
    if (!equals(this.c2r_1, tmp0_other_with_cast.c2r_1))
      return false;
    if (!equals(this.d2r_1, tmp0_other_with_cast.d2r_1))
      return false;
    if (!equals(this.e2r_1, tmp0_other_with_cast.e2r_1))
      return false;
    return true;
  };
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f2r_1 = [null, null, $serializer_init_$Create$(StringSerializer_getInstance()), null, null, null];
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductCreatedEvent', this, 6);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('ouvrageId', false);
    tmp0_serialDesc.ht('transformation', false);
    tmp0_serialDesc.ht('destination', false);
    tmp0_serialDesc.ht('time', false);
    this.g2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.g2r_1;
  };
  protoOf($serializer_2).wt = function () {
    var tmp0_cached = Companion_getInstance_3().f2r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[2]), $serializer_getInstance_25(), get_nullable($serializer_getInstance_17()), LongSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.g2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_input = decoder.ul(tmp0_desc);
    var tmp11_cached = Companion_getInstance_3().f2r_1;
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.im(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.gm(tmp0_desc, 3, $serializer_getInstance_25(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, $serializer_getInstance_17(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.am(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.im(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.gm(tmp0_desc, 3, $serializer_getInstance_25(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, $serializer_getInstance_17(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.am(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return ProductCreatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_2).h2r = function (encoder, value) {
    var tmp0_desc = this.g2r_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().f2r_1;
    tmp1_output.jn(tmp0_desc, 0, value.i2r_1);
    tmp1_output.jn(tmp0_desc, 1, value.j2r_1);
    tmp1_output.nn(tmp0_desc, 2, tmp2_cached[2], value.k2r_1);
    tmp1_output.ln(tmp0_desc, 3, $serializer_getInstance_25(), value.l2r_1);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_17(), value.m2r_1);
    tmp1_output.fn(tmp0_desc, 5, value.n2r_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.h2r(encoder, value instanceof ProductCreatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_4() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function ProductCreatedEvent_init_$Init$(seen1, id, name, ouvrageId, transformation, destination, time, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_4().g2r_1);
    }
    $this.i2r_1 = id;
    $this.j2r_1 = name;
    $this.k2r_1 = ouvrageId;
    $this.l2r_1 = transformation;
    $this.m2r_1 = destination;
    $this.n2r_1 = time;
    return $this;
  }
  function ProductCreatedEvent_init_$Create$(seen1, id, name, ouvrageId, transformation, destination, time, serializationConstructorMarker) {
    return ProductCreatedEvent_init_$Init$(seen1, id, name, ouvrageId, transformation, destination, time, serializationConstructorMarker, objectCreate(protoOf(ProductCreatedEvent)));
  }
  function ProductCreatedEvent(id, name, ouvrageId, transformation, destination, time) {
    Companion_getInstance_3();
    this.i2r_1 = id;
    this.j2r_1 = name;
    this.k2r_1 = ouvrageId;
    this.l2r_1 = transformation;
    this.m2r_1 = destination;
    this.n2r_1 = time;
  }
  protoOf(ProductCreatedEvent).k1y = function () {
    return this.i2r_1;
  };
  protoOf(ProductCreatedEvent).h9 = function () {
    return this.j2r_1;
  };
  protoOf(ProductCreatedEvent).w2q = function () {
    return this.k2r_1;
  };
  protoOf(ProductCreatedEvent).x2q = function () {
    return this.l2r_1;
  };
  protoOf(ProductCreatedEvent).y2q = function () {
    return this.m2r_1;
  };
  protoOf(ProductCreatedEvent).g2c = function () {
    return this.n2r_1;
  };
  protoOf(ProductCreatedEvent).s2Id = function () {
    return this.i2r_1;
  };
  protoOf(ProductCreatedEvent).toString = function () {
    return 'ProductCreatedEvent(id=' + this.i2r_1 + ', name=' + this.j2r_1 + ', ouvrageId=' + this.k2r_1 + ', transformation=' + this.l2r_1 + ', destination=' + this.m2r_1 + ', time=' + this.n2r_1.toString() + ')';
  };
  protoOf(ProductCreatedEvent).hashCode = function () {
    var result = getStringHashCode(this.i2r_1);
    result = imul(result, 31) + getStringHashCode(this.j2r_1) | 0;
    result = imul(result, 31) + (this.k2r_1 == null ? 0 : hashCode(this.k2r_1)) | 0;
    result = imul(result, 31) + this.l2r_1.hashCode() | 0;
    result = imul(result, 31) + (this.m2r_1 == null ? 0 : this.m2r_1.hashCode()) | 0;
    result = imul(result, 31) + this.n2r_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductCreatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductCreatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductCreatedEvent ? other : THROW_CCE();
    if (!(this.i2r_1 === tmp0_other_with_cast.i2r_1))
      return false;
    if (!(this.j2r_1 === tmp0_other_with_cast.j2r_1))
      return false;
    if (!equals(this.k2r_1, tmp0_other_with_cast.k2r_1))
      return false;
    if (!this.l2r_1.equals(tmp0_other_with_cast.l2r_1))
      return false;
    if (!equals(this.m2r_1, tmp0_other_with_cast.m2r_1))
      return false;
    if (!this.n2r_1.equals(tmp0_other_with_cast.n2r_1))
      return false;
    return true;
  };
  function ProductDeleteCommandDTO() {
  }
  function ProductDeletedEventDTO() {
  }
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.command.ProductDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.o2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.o2r_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.o2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return ProductDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_3).p2r = function (encoder, value) {
    var tmp0_desc = this.o2r_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.q2r_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.p2r(encoder, value instanceof ProductDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_5() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function ProductDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_5().o2r_1);
    }
    $this.q2r_1 = id;
    return $this;
  }
  function ProductDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return ProductDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(ProductDeleteCommand)));
  }
  function ProductDeleteCommand(id) {
    this.q2r_1 = id;
  }
  protoOf(ProductDeleteCommand).k1y = function () {
    return this.q2r_1;
  };
  protoOf(ProductDeleteCommand).toString = function () {
    return 'ProductDeleteCommand(id=' + this.q2r_1 + ')';
  };
  protoOf(ProductDeleteCommand).hashCode = function () {
    return getStringHashCode(this.q2r_1);
  };
  protoOf(ProductDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductDeleteCommand ? other : THROW_CCE();
    if (!(this.q2r_1 === tmp0_other_with_cast.q2r_1))
      return false;
    return true;
  };
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductDeletedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.r2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.r2r_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.r2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return ProductDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_4).s2r = function (encoder, value) {
    var tmp0_desc = this.r2r_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.t2r_1);
    tmp1_output.fn(tmp0_desc, 1, value.u2r_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.s2r(encoder, value instanceof ProductDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_6() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function ProductDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_6().r2r_1);
    }
    $this.t2r_1 = id;
    $this.u2r_1 = time;
    return $this;
  }
  function ProductDeletedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return ProductDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(ProductDeletedEvent)));
  }
  function ProductDeletedEvent(id, time) {
    this.t2r_1 = id;
    this.u2r_1 = time;
  }
  protoOf(ProductDeletedEvent).k1y = function () {
    return this.t2r_1;
  };
  protoOf(ProductDeletedEvent).g2c = function () {
    return this.u2r_1;
  };
  protoOf(ProductDeletedEvent).s2Id = function () {
    return this.t2r_1;
  };
  protoOf(ProductDeletedEvent).toString = function () {
    return 'ProductDeletedEvent(id=' + this.t2r_1 + ', time=' + this.u2r_1.toString() + ')';
  };
  protoOf(ProductDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.t2r_1);
    result = imul(result, 31) + this.u2r_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductDeletedEvent ? other : THROW_CCE();
    if (!(this.t2r_1 === tmp0_other_with_cast.t2r_1))
      return false;
    if (!this.u2r_1.equals(tmp0_other_with_cast.u2r_1))
      return false;
    return true;
  };
  function ProductFinishCommandDTO() {
  }
  function ProductFinishedEventDTO() {
  }
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.command.ProductFinishCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.v2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.v2r_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.v2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return ProductFinishCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_5).w2r = function (encoder, value) {
    var tmp0_desc = this.v2r_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.x2r_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.w2r(encoder, value instanceof ProductFinishCommand ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_7() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function ProductFinishCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_7().v2r_1);
    }
    $this.x2r_1 = id;
    return $this;
  }
  function ProductFinishCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return ProductFinishCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(ProductFinishCommand)));
  }
  function ProductFinishCommand(id) {
    this.x2r_1 = id;
  }
  protoOf(ProductFinishCommand).k1y = function () {
    return this.x2r_1;
  };
  protoOf(ProductFinishCommand).toString = function () {
    return 'ProductFinishCommand(id=' + this.x2r_1 + ')';
  };
  protoOf(ProductFinishCommand).hashCode = function () {
    return getStringHashCode(this.x2r_1);
  };
  protoOf(ProductFinishCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductFinishCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductFinishCommand ? other : THROW_CCE();
    if (!(this.x2r_1 === tmp0_other_with_cast.x2r_1))
      return false;
    return true;
  };
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductFinishedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.y2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.y2r_1;
  };
  protoOf($serializer_6).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.y2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return ProductFinishedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_6).z2r = function (encoder, value) {
    var tmp0_desc = this.y2r_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.a2s_1);
    tmp1_output.fn(tmp0_desc, 1, value.b2s_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.z2r(encoder, value instanceof ProductFinishedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_8() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function ProductFinishedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_8().y2r_1);
    }
    $this.a2s_1 = id;
    $this.b2s_1 = time;
    return $this;
  }
  function ProductFinishedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return ProductFinishedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(ProductFinishedEvent)));
  }
  function ProductFinishedEvent(id, time) {
    this.a2s_1 = id;
    this.b2s_1 = time;
  }
  protoOf(ProductFinishedEvent).k1y = function () {
    return this.a2s_1;
  };
  protoOf(ProductFinishedEvent).g2c = function () {
    return this.b2s_1;
  };
  protoOf(ProductFinishedEvent).s2Id = function () {
    return this.a2s_1;
  };
  protoOf(ProductFinishedEvent).toString = function () {
    return 'ProductFinishedEvent(id=' + this.a2s_1 + ', time=' + this.b2s_1.toString() + ')';
  };
  protoOf(ProductFinishedEvent).hashCode = function () {
    var result = getStringHashCode(this.a2s_1);
    result = imul(result, 31) + this.b2s_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductFinishedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductFinishedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductFinishedEvent ? other : THROW_CCE();
    if (!(this.a2s_1 === tmp0_other_with_cast.a2s_1))
      return false;
    if (!this.b2s_1.equals(tmp0_other_with_cast.b2s_1))
      return false;
    return true;
  };
  function ProductImportCommandDTO() {
  }
  function ProductImportedEventDTO() {
  }
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.command.ProductImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.c2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.c2s_1;
  };
  protoOf($serializer_7).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_22()];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.c2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return ProductImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_7).d2s = function (encoder, value) {
    var tmp0_desc = this.c2s_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_22(), value.e2s_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.d2s(encoder, value instanceof ProductImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_9() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function ProductImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_9().c2s_1);
    }
    $this.e2s_1 = item;
    return $this;
  }
  function ProductImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return ProductImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(ProductImportCommand)));
  }
  function ProductImportCommand(item) {
    this.e2s_1 = item;
  }
  protoOf(ProductImportCommand).q20 = function () {
    return this.e2s_1;
  };
  protoOf(ProductImportCommand).toString = function () {
    return 'ProductImportCommand(item=' + this.e2s_1 + ')';
  };
  protoOf(ProductImportCommand).hashCode = function () {
    return this.e2s_1.hashCode();
  };
  protoOf(ProductImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductImportCommand ? other : THROW_CCE();
    if (!this.e2s_1.equals(tmp0_other_with_cast.e2s_1))
      return false;
    return true;
  };
  function Companion_9() {
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.f2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.f2s_1;
  };
  protoOf($serializer_8).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_22(), LongSerializer_getInstance()];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.f2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return ProductImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_8).g2s = function (encoder, value) {
    var tmp0_desc = this.f2s_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_22(), value.h2s_1);
    tmp1_output.fn(tmp0_desc, 1, value.i2s_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.g2s(encoder, value instanceof ProductImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_10() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function ProductImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_10().f2s_1);
    }
    $this.h2s_1 = item;
    $this.i2s_1 = time;
    return $this;
  }
  function ProductImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return ProductImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(ProductImportedEvent)));
  }
  function ProductImportedEvent(item, time) {
    this.h2s_1 = item;
    this.i2s_1 = time;
  }
  protoOf(ProductImportedEvent).q20 = function () {
    return this.h2s_1;
  };
  protoOf(ProductImportedEvent).g2c = function () {
    return this.i2s_1;
  };
  protoOf(ProductImportedEvent).s2Id = function () {
    return this.h2s_1.j2s_1;
  };
  protoOf(ProductImportedEvent).toString = function () {
    return 'ProductImportedEvent(item=' + this.h2s_1 + ', time=' + this.i2s_1.toString() + ')';
  };
  protoOf(ProductImportedEvent).hashCode = function () {
    var result = this.h2s_1.hashCode();
    result = imul(result, 31) + this.i2s_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductImportedEvent ? other : THROW_CCE();
    if (!this.h2s_1.equals(tmp0_other_with_cast.h2s_1))
      return false;
    if (!this.i2s_1.equals(tmp0_other_with_cast.i2s_1))
      return false;
    return true;
  };
  function ProductInitLinkedCommandDTO() {
  }
  function ProductInitializedLinkedEventDTO() {
  }
  function Companion_10() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v2s_1 = [null, $serializer_init_$Create$(StringSerializer_getInstance()), $serializer_init_$Create$(StringSerializer_getInstance()), null];
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.command.ProductInitLinkedCommand', this, 4);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('ouvrageId', false);
    tmp0_serialDesc.ht('actor', false);
    tmp0_serialDesc.ht('destination', true);
    this.w2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).ii = function () {
    return this.w2s_1;
  };
  protoOf($serializer_9).wt = function () {
    var tmp0_cached = Companion_getInstance_10().v2s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(tmp0_cached[1]), tmp0_cached[2], get_nullable($serializer_getInstance_17())];
  };
  protoOf($serializer_9).ki = function (decoder) {
    var tmp0_desc = this.w2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    var tmp9_cached = Companion_getInstance_10().v2s_1;
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.im(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.gm(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, $serializer_getInstance_17(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.im(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.gm(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, $serializer_getInstance_17(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return ProductInitLinkedCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_9).x2s = function (encoder, value) {
    var tmp0_desc = this.w2s_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().v2s_1;
    tmp1_output.jn(tmp0_desc, 0, value.y2s_1);
    tmp1_output.nn(tmp0_desc, 1, tmp2_cached[1], value.z2s_1);
    tmp1_output.ln(tmp0_desc, 2, tmp2_cached[2], value.a2t_1);
    if (tmp1_output.rn(tmp0_desc, 3) ? true : !(value.b2t_1 == null)) {
      tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance_17(), value.b2t_1);
    }
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_9).ji = function (encoder, value) {
    return this.x2s(encoder, value instanceof ProductInitLinkedCommand ? value : THROW_CCE());
  };
  var $serializer_instance_9;
  function $serializer_getInstance_11() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function ProductInitLinkedCommand_init_$Init$(seen1, name, ouvrageId, actor, destination, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_11().w2s_1);
    }
    $this.y2s_1 = name;
    $this.z2s_1 = ouvrageId;
    $this.a2t_1 = actor;
    if (0 === (seen1 & 8))
      $this.b2t_1 = null;
    else
      $this.b2t_1 = destination;
    return $this;
  }
  function ProductInitLinkedCommand_init_$Create$(seen1, name, ouvrageId, actor, destination, serializationConstructorMarker) {
    return ProductInitLinkedCommand_init_$Init$(seen1, name, ouvrageId, actor, destination, serializationConstructorMarker, objectCreate(protoOf(ProductInitLinkedCommand)));
  }
  function ProductInitLinkedCommand(name, ouvrageId, actor, destination) {
    Companion_getInstance_10();
    destination = destination === VOID ? null : destination;
    this.y2s_1 = name;
    this.z2s_1 = ouvrageId;
    this.a2t_1 = actor;
    this.b2t_1 = destination;
  }
  protoOf(ProductInitLinkedCommand).h9 = function () {
    return this.y2s_1;
  };
  protoOf(ProductInitLinkedCommand).w2q = function () {
    return this.z2s_1;
  };
  protoOf(ProductInitLinkedCommand).t2q = function () {
    return this.a2t_1;
  };
  protoOf(ProductInitLinkedCommand).y2q = function () {
    return this.b2t_1;
  };
  protoOf(ProductInitLinkedCommand).toString = function () {
    return 'ProductInitLinkedCommand(name=' + this.y2s_1 + ', ouvrageId=' + this.z2s_1 + ', actor=' + this.a2t_1 + ', destination=' + this.b2t_1 + ')';
  };
  protoOf(ProductInitLinkedCommand).hashCode = function () {
    var result = getStringHashCode(this.y2s_1);
    result = imul(result, 31) + (this.z2s_1 == null ? 0 : hashCode(this.z2s_1)) | 0;
    result = imul(result, 31) + hashCode(this.a2t_1) | 0;
    result = imul(result, 31) + (this.b2t_1 == null ? 0 : this.b2t_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProductInitLinkedCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductInitLinkedCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductInitLinkedCommand ? other : THROW_CCE();
    if (!(this.y2s_1 === tmp0_other_with_cast.y2s_1))
      return false;
    if (!equals(this.z2s_1, tmp0_other_with_cast.z2s_1))
      return false;
    if (!equals(this.a2t_1, tmp0_other_with_cast.a2t_1))
      return false;
    if (!equals(this.b2t_1, tmp0_other_with_cast.b2t_1))
      return false;
    return true;
  };
  function ProductRenameCommandDTO() {
  }
  function ProductRenamedEventDTO() {
  }
  function ProductRenameCommand(id, name) {
    this.c2t_1 = id;
    this.d2t_1 = name;
  }
  protoOf(ProductRenameCommand).k1y = function () {
    return this.c2t_1;
  };
  protoOf(ProductRenameCommand).h9 = function () {
    return this.d2t_1;
  };
  protoOf(ProductRenameCommand).toString = function () {
    return 'ProductRenameCommand(id=' + this.c2t_1 + ', name=' + this.d2t_1 + ')';
  };
  protoOf(ProductRenameCommand).hashCode = function () {
    var result = getStringHashCode(this.c2t_1);
    result = imul(result, 31) + getStringHashCode(this.d2t_1) | 0;
    return result;
  };
  protoOf(ProductRenameCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductRenameCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductRenameCommand ? other : THROW_CCE();
    if (!(this.c2t_1 === tmp0_other_with_cast.c2t_1))
      return false;
    if (!(this.d2t_1 === tmp0_other_with_cast.d2t_1))
      return false;
    return true;
  };
  function Companion_11() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2t_1 = [null, Companion_getInstance().x14(), null, null];
  }
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductRenamedEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('time', false);
    this.f2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).ii = function () {
    return this.f2t_1;
  };
  protoOf($serializer_10).wt = function () {
    var tmp0_cached = Companion_getInstance_11().e2t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_10).ki = function (decoder) {
    var tmp0_desc = this.f2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_input = decoder.ul(tmp0_desc);
    var tmp9_cached = Companion_getInstance_11().e2t_1;
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.gm(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.am(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.gm(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.am(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return ProductRenamedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_10).g2t = function (encoder, value) {
    var tmp0_desc = this.f2t_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_11().e2t_1;
    tmp1_output.jn(tmp0_desc, 0, value.h2t_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.i2t_1);
    tmp1_output.jn(tmp0_desc, 2, value.j2t_1);
    tmp1_output.fn(tmp0_desc, 3, value.k2t_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_10).ji = function (encoder, value) {
    return this.g2t(encoder, value instanceof ProductRenamedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_10;
  function $serializer_getInstance_12() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function ProductRenamedEvent_init_$Init$(seen1, id, status, name, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_12().f2t_1);
    }
    $this.h2t_1 = id;
    $this.i2t_1 = status;
    $this.j2t_1 = name;
    $this.k2t_1 = time;
    return $this;
  }
  function ProductRenamedEvent_init_$Create$(seen1, id, status, name, time, serializationConstructorMarker) {
    return ProductRenamedEvent_init_$Init$(seen1, id, status, name, time, serializationConstructorMarker, objectCreate(protoOf(ProductRenamedEvent)));
  }
  function ProductRenamedEvent(id, status, name, time) {
    Companion_getInstance_11();
    this.h2t_1 = id;
    this.i2t_1 = status;
    this.j2t_1 = name;
    this.k2t_1 = time;
  }
  protoOf(ProductRenamedEvent).k1y = function () {
    return this.h2t_1;
  };
  protoOf(ProductRenamedEvent).y2f = function () {
    return this.i2t_1;
  };
  protoOf(ProductRenamedEvent).h9 = function () {
    return this.j2t_1;
  };
  protoOf(ProductRenamedEvent).g2c = function () {
    return this.k2t_1;
  };
  protoOf(ProductRenamedEvent).s2Id = function () {
    return this.h2t_1;
  };
  protoOf(ProductRenamedEvent).toString = function () {
    return 'ProductRenamedEvent(id=' + this.h2t_1 + ', status=' + this.i2t_1 + ', name=' + this.j2t_1 + ', time=' + this.k2t_1.toString() + ')';
  };
  protoOf(ProductRenamedEvent).hashCode = function () {
    var result = getStringHashCode(this.h2t_1);
    result = imul(result, 31) + this.i2t_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.j2t_1) | 0;
    result = imul(result, 31) + this.k2t_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductRenamedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductRenamedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductRenamedEvent ? other : THROW_CCE();
    if (!(this.h2t_1 === tmp0_other_with_cast.h2t_1))
      return false;
    if (!this.i2t_1.equals(tmp0_other_with_cast.i2t_1))
      return false;
    if (!(this.j2t_1 === tmp0_other_with_cast.j2t_1))
      return false;
    if (!this.k2t_1.equals(tmp0_other_with_cast.k2t_1))
      return false;
    return true;
  };
  function ProductTransformationActorDefineCommandDTO() {
  }
  function ProductTransformationActorDefinedEventDTO() {
  }
  function ProductTransformationActorDefineCommand(id, actor) {
    this.l2t_1 = id;
    this.m2t_1 = actor;
  }
  protoOf(ProductTransformationActorDefineCommand).k1y = function () {
    return this.l2t_1;
  };
  protoOf(ProductTransformationActorDefineCommand).t2q = function () {
    return this.m2t_1;
  };
  protoOf(ProductTransformationActorDefineCommand).toString = function () {
    return 'ProductTransformationActorDefineCommand(id=' + this.l2t_1 + ', actor=' + this.m2t_1 + ')';
  };
  protoOf(ProductTransformationActorDefineCommand).hashCode = function () {
    var result = getStringHashCode(this.l2t_1);
    result = imul(result, 31) + hashCode(this.m2t_1) | 0;
    return result;
  };
  protoOf(ProductTransformationActorDefineCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTransformationActorDefineCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTransformationActorDefineCommand ? other : THROW_CCE();
    if (!(this.l2t_1 === tmp0_other_with_cast.l2t_1))
      return false;
    if (!equals(this.m2t_1, tmp0_other_with_cast.m2t_1))
      return false;
    return true;
  };
  function Companion_12() {
  }
  var Companion_instance_12;
  function Companion_getInstance_12() {
    return Companion_instance_12;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductTransformationActorDefinedEvent', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('actor', false);
    tmp0_serialDesc.ht('time', false);
    this.n2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).ii = function () {
    return this.n2t_1;
  };
  protoOf($serializer_11).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_11).ki = function (decoder) {
    var tmp0_desc = this.n2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.gm(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.am(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.gm(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.am(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return ProductTransformationActorDefinedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_11).o2t = function (encoder, value) {
    var tmp0_desc = this.n2t_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.p2t_1);
    tmp1_output.ln(tmp0_desc, 1, $serializer_getInstance(), value.q2t_1);
    tmp1_output.fn(tmp0_desc, 2, value.r2t_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_11).ji = function (encoder, value) {
    return this.o2t(encoder, value instanceof ProductTransformationActorDefinedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_11;
  function $serializer_getInstance_13() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function ProductTransformationActorDefinedEvent_init_$Init$(seen1, id, actor, time, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_13().n2t_1);
    }
    $this.p2t_1 = id;
    $this.q2t_1 = actor;
    $this.r2t_1 = time;
    return $this;
  }
  function ProductTransformationActorDefinedEvent_init_$Create$(seen1, id, actor, time, serializationConstructorMarker) {
    return ProductTransformationActorDefinedEvent_init_$Init$(seen1, id, actor, time, serializationConstructorMarker, objectCreate(protoOf(ProductTransformationActorDefinedEvent)));
  }
  function ProductTransformationActorDefinedEvent(id, actor, time) {
    this.p2t_1 = id;
    this.q2t_1 = actor;
    this.r2t_1 = time;
  }
  protoOf(ProductTransformationActorDefinedEvent).k1y = function () {
    return this.p2t_1;
  };
  protoOf(ProductTransformationActorDefinedEvent).t2q = function () {
    return this.q2t_1;
  };
  protoOf(ProductTransformationActorDefinedEvent).g2c = function () {
    return this.r2t_1;
  };
  protoOf(ProductTransformationActorDefinedEvent).s2Id = function () {
    return this.p2t_1;
  };
  protoOf(ProductTransformationActorDefinedEvent).toString = function () {
    return 'ProductTransformationActorDefinedEvent(id=' + this.p2t_1 + ', actor=' + this.q2t_1 + ', time=' + this.r2t_1.toString() + ')';
  };
  protoOf(ProductTransformationActorDefinedEvent).hashCode = function () {
    var result = getStringHashCode(this.p2t_1);
    result = imul(result, 31) + this.q2t_1.hashCode() | 0;
    result = imul(result, 31) + this.r2t_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductTransformationActorDefinedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTransformationActorDefinedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTransformationActorDefinedEvent ? other : THROW_CCE();
    if (!(this.p2t_1 === tmp0_other_with_cast.p2t_1))
      return false;
    if (!this.q2t_1.equals(tmp0_other_with_cast.q2t_1))
      return false;
    if (!this.r2t_1.equals(tmp0_other_with_cast.r2t_1))
      return false;
    return true;
  };
  function ProductUnlockCommandDTO() {
  }
  function ProductUnlockedEventDTO() {
  }
  function Companion_13() {
  }
  var Companion_instance_13;
  function Companion_getInstance_13() {
    return Companion_instance_13;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.command.ProductUnlockCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.s2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).ii = function () {
    return this.s2t_1;
  };
  protoOf($serializer_12).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_12).ki = function (decoder) {
    var tmp0_desc = this.s2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return ProductUnlockCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_12).t2t = function (encoder, value) {
    var tmp0_desc = this.s2t_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.u2t_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_12).ji = function (encoder, value) {
    return this.t2t(encoder, value instanceof ProductUnlockCommand ? value : THROW_CCE());
  };
  var $serializer_instance_12;
  function $serializer_getInstance_14() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function ProductUnlockCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_14().s2t_1);
    }
    $this.u2t_1 = id;
    return $this;
  }
  function ProductUnlockCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return ProductUnlockCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(ProductUnlockCommand)));
  }
  function ProductUnlockCommand(id) {
    this.u2t_1 = id;
  }
  protoOf(ProductUnlockCommand).k1y = function () {
    return this.u2t_1;
  };
  protoOf(ProductUnlockCommand).toString = function () {
    return 'ProductUnlockCommand(id=' + this.u2t_1 + ')';
  };
  protoOf(ProductUnlockCommand).hashCode = function () {
    return getStringHashCode(this.u2t_1);
  };
  protoOf(ProductUnlockCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductUnlockCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductUnlockCommand ? other : THROW_CCE();
    if (!(this.u2t_1 === tmp0_other_with_cast.u2t_1))
      return false;
    return true;
  };
  function Companion_14() {
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    return Companion_instance_14;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductUnlockedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.v2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).ii = function () {
    return this.v2t_1;
  };
  protoOf($serializer_13).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_13).ki = function (decoder) {
    var tmp0_desc = this.v2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return ProductUnlockedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_13).w2t = function (encoder, value) {
    var tmp0_desc = this.v2t_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.x2t_1);
    tmp1_output.fn(tmp0_desc, 1, value.y2t_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_13).ji = function (encoder, value) {
    return this.w2t(encoder, value instanceof ProductUnlockedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_13;
  function $serializer_getInstance_15() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function ProductUnlockedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_15().v2t_1);
    }
    $this.x2t_1 = id;
    $this.y2t_1 = time;
    return $this;
  }
  function ProductUnlockedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return ProductUnlockedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(ProductUnlockedEvent)));
  }
  function ProductUnlockedEvent(id, time) {
    this.x2t_1 = id;
    this.y2t_1 = time;
  }
  protoOf(ProductUnlockedEvent).k1y = function () {
    return this.x2t_1;
  };
  protoOf(ProductUnlockedEvent).g2c = function () {
    return this.y2t_1;
  };
  protoOf(ProductUnlockedEvent).s2Id = function () {
    return this.x2t_1;
  };
  protoOf(ProductUnlockedEvent).toString = function () {
    return 'ProductUnlockedEvent(id=' + this.x2t_1 + ', time=' + this.y2t_1.toString() + ')';
  };
  protoOf(ProductUnlockedEvent).hashCode = function () {
    var result = getStringHashCode(this.x2t_1);
    result = imul(result, 31) + this.y2t_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductUnlockedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductUnlockedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductUnlockedEvent ? other : THROW_CCE();
    if (!(this.x2t_1 === tmp0_other_with_cast.x2t_1))
      return false;
    if (!this.y2t_1.equals(tmp0_other_with_cast.y2t_1))
      return false;
    return true;
  };
  function ProductUpdateCommandDTO() {
  }
  function ProductUpdatedEventDTO() {
  }
  function ProductUpdateCommand(id, ouvrage, source, destination, origin) {
    this.z2t_1 = id;
    this.a2u_1 = ouvrage;
    this.b2u_1 = source;
    this.c2u_1 = destination;
    this.d2u_1 = origin;
  }
  protoOf(ProductUpdateCommand).k1y = function () {
    return this.z2t_1;
  };
  protoOf(ProductUpdateCommand).v2q = function () {
    return this.a2u_1;
  };
  protoOf(ProductUpdateCommand).s1c = function () {
    return this.b2u_1;
  };
  protoOf(ProductUpdateCommand).y2q = function () {
    return this.c2u_1;
  };
  protoOf(ProductUpdateCommand).i23 = function () {
    return this.d2u_1;
  };
  protoOf(ProductUpdateCommand).toString = function () {
    return 'ProductUpdateCommand(id=' + this.z2t_1 + ', ouvrage=' + this.a2u_1 + ', source=' + this.b2u_1 + ', destination=' + this.c2u_1 + ', origin=' + this.d2u_1 + ')';
  };
  protoOf(ProductUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.z2t_1);
    result = imul(result, 31) + (this.a2u_1 == null ? 0 : hashCode(this.a2u_1)) | 0;
    result = imul(result, 31) + (this.b2u_1 == null ? 0 : this.b2u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.c2u_1 == null ? 0 : this.c2u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.d2u_1 == null ? 0 : hashCode(this.d2u_1)) | 0;
    return result;
  };
  protoOf(ProductUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductUpdateCommand ? other : THROW_CCE();
    if (!(this.z2t_1 === tmp0_other_with_cast.z2t_1))
      return false;
    if (!equals(this.a2u_1, tmp0_other_with_cast.a2u_1))
      return false;
    if (!equals(this.b2u_1, tmp0_other_with_cast.b2u_1))
      return false;
    if (!equals(this.c2u_1, tmp0_other_with_cast.c2u_1))
      return false;
    if (!equals(this.d2u_1, tmp0_other_with_cast.d2u_1))
      return false;
    return true;
  };
  function Companion_15() {
    Companion_instance_15 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2u_1 = [null, $serializer_init_$Create$(StringSerializer_getInstance()), Companion_getInstance().x14(), null, null, null, null];
  }
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_15();
    return Companion_instance_15;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductUpdatedEvent', this, 7);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('ouvrage', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('source', false);
    tmp0_serialDesc.ht('destination', false);
    tmp0_serialDesc.ht('origin', false);
    tmp0_serialDesc.ht('time', false);
    this.f2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).ii = function () {
    return this.f2u_1;
  };
  protoOf($serializer_14).wt = function () {
    var tmp0_cached = Companion_getInstance_15().e2u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(tmp0_cached[1]), tmp0_cached[2], get_nullable($serializer_getInstance_23()), get_nullable($serializer_getInstance_17()), get_nullable($serializer_getInstance_19()), LongSerializer_getInstance()];
  };
  protoOf($serializer_14).ki = function (decoder) {
    var tmp0_desc = this.f2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = new Long(0, 0);
    var tmp11_input = decoder.ul(tmp0_desc);
    var tmp12_cached = Companion_getInstance_15().e2u_1;
    if (tmp11_input.km()) {
      tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.im(tmp0_desc, 1, tmp12_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.gm(tmp0_desc, 2, tmp12_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.im(tmp0_desc, 3, $serializer_getInstance_23(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.im(tmp0_desc, 4, $serializer_getInstance_17(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.im(tmp0_desc, 5, $serializer_getInstance_19(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.am(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.im(tmp0_desc, 1, tmp12_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.gm(tmp0_desc, 2, tmp12_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.im(tmp0_desc, 3, $serializer_getInstance_23(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.im(tmp0_desc, 4, $serializer_getInstance_17(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.im(tmp0_desc, 5, $serializer_getInstance_19(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.am(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.vl(tmp0_desc);
    return ProductUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_14).g2u = function (encoder, value) {
    var tmp0_desc = this.f2u_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_15().e2u_1;
    tmp1_output.jn(tmp0_desc, 0, value.h2u_1);
    tmp1_output.nn(tmp0_desc, 1, tmp2_cached[1], value.i2u_1);
    tmp1_output.ln(tmp0_desc, 2, tmp2_cached[2], value.j2u_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance_23(), value.k2u_1);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_17(), value.l2u_1);
    tmp1_output.nn(tmp0_desc, 5, $serializer_getInstance_19(), value.m2u_1);
    tmp1_output.fn(tmp0_desc, 6, value.n2u_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_14).ji = function (encoder, value) {
    return this.g2u(encoder, value instanceof ProductUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_14;
  function $serializer_getInstance_16() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function ProductUpdatedEvent_init_$Init$(seen1, id, ouvrage, status, source, destination, origin, time, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen1))) {
      throwMissingFieldException(seen1, 127, $serializer_getInstance_16().f2u_1);
    }
    $this.h2u_1 = id;
    $this.i2u_1 = ouvrage;
    $this.j2u_1 = status;
    $this.k2u_1 = source;
    $this.l2u_1 = destination;
    $this.m2u_1 = origin;
    $this.n2u_1 = time;
    return $this;
  }
  function ProductUpdatedEvent_init_$Create$(seen1, id, ouvrage, status, source, destination, origin, time, serializationConstructorMarker) {
    return ProductUpdatedEvent_init_$Init$(seen1, id, ouvrage, status, source, destination, origin, time, serializationConstructorMarker, objectCreate(protoOf(ProductUpdatedEvent)));
  }
  function ProductUpdatedEvent(id, ouvrage, status, source, destination, origin, time) {
    Companion_getInstance_15();
    this.h2u_1 = id;
    this.i2u_1 = ouvrage;
    this.j2u_1 = status;
    this.k2u_1 = source;
    this.l2u_1 = destination;
    this.m2u_1 = origin;
    this.n2u_1 = time;
  }
  protoOf(ProductUpdatedEvent).k1y = function () {
    return this.h2u_1;
  };
  protoOf(ProductUpdatedEvent).v2q = function () {
    return this.i2u_1;
  };
  protoOf(ProductUpdatedEvent).y2f = function () {
    return this.j2u_1;
  };
  protoOf(ProductUpdatedEvent).s1c = function () {
    return this.k2u_1;
  };
  protoOf(ProductUpdatedEvent).y2q = function () {
    return this.l2u_1;
  };
  protoOf(ProductUpdatedEvent).i23 = function () {
    return this.m2u_1;
  };
  protoOf(ProductUpdatedEvent).g2c = function () {
    return this.n2u_1;
  };
  protoOf(ProductUpdatedEvent).s2Id = function () {
    return this.h2u_1;
  };
  protoOf(ProductUpdatedEvent).toString = function () {
    return 'ProductUpdatedEvent(id=' + this.h2u_1 + ', ouvrage=' + this.i2u_1 + ', status=' + this.j2u_1 + ', source=' + this.k2u_1 + ', destination=' + this.l2u_1 + ', origin=' + this.m2u_1 + ', time=' + this.n2u_1.toString() + ')';
  };
  protoOf(ProductUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.h2u_1);
    result = imul(result, 31) + (this.i2u_1 == null ? 0 : hashCode(this.i2u_1)) | 0;
    result = imul(result, 31) + this.j2u_1.hashCode() | 0;
    result = imul(result, 31) + (this.k2u_1 == null ? 0 : this.k2u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.l2u_1 == null ? 0 : this.l2u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.m2u_1 == null ? 0 : hashCode(this.m2u_1)) | 0;
    result = imul(result, 31) + this.n2u_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductUpdatedEvent ? other : THROW_CCE();
    if (!(this.h2u_1 === tmp0_other_with_cast.h2u_1))
      return false;
    if (!equals(this.i2u_1, tmp0_other_with_cast.i2u_1))
      return false;
    if (!this.j2u_1.equals(tmp0_other_with_cast.j2u_1))
      return false;
    if (!equals(this.k2u_1, tmp0_other_with_cast.k2u_1))
      return false;
    if (!equals(this.l2u_1, tmp0_other_with_cast.l2u_1))
      return false;
    if (!equals(this.m2u_1, tmp0_other_with_cast.m2u_1))
      return false;
    if (!this.n2u_1.equals(tmp0_other_with_cast.n2u_1))
      return false;
    return true;
  };
  function DestinationModelDTO() {
  }
  function EndProductModelDTO() {
  }
  function Companion_16() {
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t2u_1 = [$serializer_init_$Create$(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_18())];
  }
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_16();
    return Companion_instance_16;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.DestinationModel', this, 2);
    tmp0_serialDesc.ht('client', false);
    tmp0_serialDesc.ht('endProduct', false);
    this.u2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).ii = function () {
    return this.u2u_1;
  };
  protoOf($serializer_15).wt = function () {
    var tmp0_cached = Companion_getInstance_16().t2u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1])];
  };
  protoOf($serializer_15).ki = function (decoder) {
    var tmp0_desc = this.u2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    var tmp7_cached = Companion_getInstance_16().t2u_1;
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.im(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.im(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return DestinationModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_15).v2u = function (encoder, value) {
    var tmp0_desc = this.u2u_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().t2u_1;
    tmp1_output.nn(tmp0_desc, 0, tmp2_cached[0], value.w2u_1);
    tmp1_output.nn(tmp0_desc, 1, tmp2_cached[1], value.x2u_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_15).ji = function (encoder, value) {
    return this.v2u(encoder, value instanceof DestinationModel ? value : THROW_CCE());
  };
  var $serializer_instance_15;
  function $serializer_getInstance_17() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function DestinationModel_init_$Init$(seen1, client, endProduct, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_17().u2u_1);
    }
    $this.w2u_1 = client;
    $this.x2u_1 = endProduct;
    return $this;
  }
  function DestinationModel_init_$Create$(seen1, client, endProduct, serializationConstructorMarker) {
    return DestinationModel_init_$Init$(seen1, client, endProduct, serializationConstructorMarker, objectCreate(protoOf(DestinationModel)));
  }
  function DestinationModel() {
  }
  protoOf(DestinationModel).o2u = function () {
    return this.w2u_1;
  };
  protoOf(DestinationModel).p2u = function () {
    return this.x2u_1;
  };
  protoOf(DestinationModel).toString = function () {
    return 'DestinationModel(client=' + this.w2u_1 + ', endProduct=' + this.x2u_1 + ')';
  };
  protoOf(DestinationModel).hashCode = function () {
    var result = this.w2u_1 == null ? 0 : hashCode(this.w2u_1);
    result = imul(result, 31) + (this.x2u_1 == null ? 0 : hashCode(this.x2u_1)) | 0;
    return result;
  };
  protoOf(DestinationModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DestinationModel))
      return false;
    var tmp0_other_with_cast = other instanceof DestinationModel ? other : THROW_CCE();
    if (!equals(this.w2u_1, tmp0_other_with_cast.w2u_1))
      return false;
    if (!equals(this.x2u_1, tmp0_other_with_cast.x2u_1))
      return false;
    return true;
  };
  function Companion_17() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y2u_1 = [$serializer_init_$Create$(StringSerializer_getInstance()), $serializer_init_$Create$(StringSerializer_getInstance()), new ArrayListSerializer($serializer_init_$Create$(StringSerializer_getInstance())), null];
  }
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_17();
    return Companion_instance_17;
  }
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.EndProductModel', this, 4);
    tmp0_serialDesc.ht('product', true);
    tmp0_serialDesc.ht('productType', true);
    tmp0_serialDesc.ht('productTypes', false);
    tmp0_serialDesc.ht('metrics', true);
    this.z2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).ii = function () {
    return this.z2u_1;
  };
  protoOf($serializer_16).wt = function () {
    var tmp0_cached = Companion_getInstance_17().y2u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2]), get_nullable($serializer_getInstance_21())];
  };
  protoOf($serializer_16).ki = function (decoder) {
    var tmp0_desc = this.z2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    var tmp9_cached = Companion_getInstance_17().y2u_1;
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.im(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.im(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, $serializer_getInstance_21(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.im(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.im(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, $serializer_getInstance_21(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return EndProductModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_16).a2v = function (encoder, value) {
    var tmp0_desc = this.z2u_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_17().y2u_1;
    if (tmp1_output.rn(tmp0_desc, 0) ? true : !(value.b2v_1 == null)) {
      tmp1_output.nn(tmp0_desc, 0, tmp2_cached[0], value.b2v_1);
    }
    if (tmp1_output.rn(tmp0_desc, 1) ? true : !(value.c2v_1 == null)) {
      tmp1_output.nn(tmp0_desc, 1, tmp2_cached[1], value.c2v_1);
    }
    tmp1_output.nn(tmp0_desc, 2, tmp2_cached[2], value.d2v_1);
    if (tmp1_output.rn(tmp0_desc, 3) ? true : !(value.e2v_1 == null)) {
      tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance_21(), value.e2v_1);
    }
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_16).ji = function (encoder, value) {
    return this.a2v(encoder, value instanceof EndProductModel ? value : THROW_CCE());
  };
  var $serializer_instance_16;
  function $serializer_getInstance_18() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function EndProductModel_init_$Init$(seen1, product, productType, productTypes, metrics, serializationConstructorMarker, $this) {
    if (!(4 === (4 & seen1))) {
      throwMissingFieldException(seen1, 4, $serializer_getInstance_18().z2u_1);
    }
    if (0 === (seen1 & 1))
      $this.b2v_1 = null;
    else
      $this.b2v_1 = product;
    if (0 === (seen1 & 2))
      $this.c2v_1 = null;
    else
      $this.c2v_1 = productType;
    $this.d2v_1 = productTypes;
    if (0 === (seen1 & 8))
      $this.e2v_1 = null;
    else
      $this.e2v_1 = metrics;
    return $this;
  }
  function EndProductModel_init_$Create$(seen1, product, productType, productTypes, metrics, serializationConstructorMarker) {
    return EndProductModel_init_$Init$(seen1, product, productType, productTypes, metrics, serializationConstructorMarker, objectCreate(protoOf(EndProductModel)));
  }
  function EndProductModel() {
  }
  protoOf(EndProductModel).q2u = function () {
    return this.b2v_1;
  };
  protoOf(EndProductModel).u2q = function () {
    return this.c2v_1;
  };
  protoOf(EndProductModel).r2u = function () {
    return this.d2v_1;
  };
  protoOf(EndProductModel).s2u = function () {
    return this.e2v_1;
  };
  protoOf(EndProductModel).toString = function () {
    return 'EndProductModel(product=' + this.b2v_1 + ', productType=' + this.c2v_1 + ', productTypes=' + this.d2v_1 + ', metrics=' + this.e2v_1 + ')';
  };
  protoOf(EndProductModel).hashCode = function () {
    var result = this.b2v_1 == null ? 0 : hashCode(this.b2v_1);
    result = imul(result, 31) + (this.c2v_1 == null ? 0 : hashCode(this.c2v_1)) | 0;
    result = imul(result, 31) + (this.d2v_1 == null ? 0 : hashCode(this.d2v_1)) | 0;
    result = imul(result, 31) + (this.e2v_1 == null ? 0 : this.e2v_1.hashCode()) | 0;
    return result;
  };
  protoOf(EndProductModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EndProductModel))
      return false;
    var tmp0_other_with_cast = other instanceof EndProductModel ? other : THROW_CCE();
    if (!equals(this.b2v_1, tmp0_other_with_cast.b2v_1))
      return false;
    if (!equals(this.c2v_1, tmp0_other_with_cast.c2v_1))
      return false;
    if (!equals(this.d2v_1, tmp0_other_with_cast.d2v_1))
      return false;
    if (!equals(this.e2v_1, tmp0_other_with_cast.e2v_1))
      return false;
    return true;
  };
  function OriginModelDTO() {
  }
  function OriginZoneModelDTO() {
  }
  function Companion_18() {
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2v_1 = [new ArrayListSerializer($serializer_getInstance_20())];
  }
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_18();
    return Companion_instance_18;
  }
  function $serializer_17() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.OriginModel', this, 1);
    tmp0_serialDesc.ht('zones', false);
    this.i2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).ii = function () {
    return this.i2v_1;
  };
  protoOf($serializer_17).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_18().h2v_1[0]];
  };
  protoOf($serializer_17).ki = function (decoder) {
    var tmp0_desc = this.i2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    var tmp6_cached = Companion_getInstance_18().h2v_1;
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OriginModel_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_17).j2v = function (encoder, value) {
    var tmp0_desc = this.i2v_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_18().h2v_1;
    tmp1_output.ln(tmp0_desc, 0, tmp2_cached[0], value.k2v_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_17).ji = function (encoder, value) {
    return this.j2v(encoder, value instanceof OriginModel ? value : THROW_CCE());
  };
  var $serializer_instance_17;
  function $serializer_getInstance_19() {
    if ($serializer_instance_17 == null)
      new $serializer_17();
    return $serializer_instance_17;
  }
  function OriginModel_init_$Init$(seen1, zones, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_19().i2v_1);
    }
    $this.k2v_1 = zones;
    return $this;
  }
  function OriginModel_init_$Create$(seen1, zones, serializationConstructorMarker) {
    return OriginModel_init_$Init$(seen1, zones, serializationConstructorMarker, objectCreate(protoOf(OriginModel)));
  }
  function OriginModel() {
  }
  protoOf(OriginModel).f2v = function () {
    return this.k2v_1;
  };
  function Companion_19() {
    Companion_instance_19 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l2v_1 = [$serializer_init_$Create$(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_19();
    return Companion_instance_19;
  }
  function $serializer_18() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.OriginZoneModel', this, 3);
    tmp0_serialDesc.ht('removalZone', false);
    tmp0_serialDesc.ht('metrics', false);
    tmp0_serialDesc.ht('type', false);
    this.m2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).ii = function () {
    return this.m2v_1;
  };
  protoOf($serializer_18).wt = function () {
    var tmp0_cached = Companion_getInstance_19().l2v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable($serializer_getInstance_21()), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_18).ki = function (decoder) {
    var tmp0_desc = this.m2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    var tmp8_cached = Companion_getInstance_19().l2v_1;
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.im(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.im(tmp0_desc, 1, $serializer_getInstance_21(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.im(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.im(tmp0_desc, 1, $serializer_getInstance_21(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return OriginZoneModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_18).n2v = function (encoder, value) {
    var tmp0_desc = this.m2v_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_19().l2v_1;
    tmp1_output.nn(tmp0_desc, 0, tmp2_cached[0], value.o2v_1);
    tmp1_output.nn(tmp0_desc, 1, $serializer_getInstance_21(), value.p2v_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.q2v_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_18).ji = function (encoder, value) {
    return this.n2v(encoder, value instanceof OriginZoneModel ? value : THROW_CCE());
  };
  var $serializer_instance_18;
  function $serializer_getInstance_20() {
    if ($serializer_instance_18 == null)
      new $serializer_18();
    return $serializer_instance_18;
  }
  function OriginZoneModel_init_$Init$(seen1, removalZone, metrics, type, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_20().m2v_1);
    }
    $this.o2v_1 = removalZone;
    $this.p2v_1 = metrics;
    $this.q2v_1 = type;
    return $this;
  }
  function OriginZoneModel_init_$Create$(seen1, removalZone, metrics, type, serializationConstructorMarker) {
    return OriginZoneModel_init_$Init$(seen1, removalZone, metrics, type, serializationConstructorMarker, objectCreate(protoOf(OriginZoneModel)));
  }
  function OriginZoneModel() {
  }
  protoOf(OriginZoneModel).g2v = function () {
    return this.o2v_1;
  };
  protoOf(OriginZoneModel).s2u = function () {
    return this.p2v_1;
  };
  protoOf(OriginZoneModel).j21 = function () {
    return this.q2v_1;
  };
  function ProductMetricsDTO() {
  }
  function Companion_20() {
    Companion_instance_20 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t2v_1 = [null, null, $serializer_init_$Create$(StringSerializer_getInstance()), new ArrayListSerializer($serializer_init_$Create$(StringSerializer_getInstance()))];
  }
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_20();
    return Companion_instance_20;
  }
  function $serializer_19() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.ProductMetrics', this, 4);
    tmp0_serialDesc.ht('quantity', false);
    tmp0_serialDesc.ht('unit', false);
    tmp0_serialDesc.ht('woodSpecies', false);
    tmp0_serialDesc.ht('species', false);
    this.u2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).ii = function () {
    return this.u2v_1;
  };
  protoOf($serializer_19).wt = function () {
    var tmp0_cached = Companion_getInstance_20().t2v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(DoubleSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[2]), get_nullable(tmp0_cached[3])];
  };
  protoOf($serializer_19).ki = function (decoder) {
    var tmp0_desc = this.u2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    var tmp9_cached = Companion_getInstance_20().t2v_1;
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.im(tmp0_desc, 0, DoubleSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.im(tmp0_desc, 0, DoubleSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return ProductMetrics_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_19).v2v = function (encoder, value) {
    var tmp0_desc = this.u2v_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_20().t2v_1;
    tmp1_output.nn(tmp0_desc, 0, DoubleSerializer_getInstance(), value.w2v_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.x2v_1);
    tmp1_output.nn(tmp0_desc, 2, tmp2_cached[2], value.y2v_1);
    tmp1_output.nn(tmp0_desc, 3, tmp2_cached[3], value.z2v_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_19).ji = function (encoder, value) {
    return this.v2v(encoder, value instanceof ProductMetrics ? value : THROW_CCE());
  };
  var $serializer_instance_19;
  function $serializer_getInstance_21() {
    if ($serializer_instance_19 == null)
      new $serializer_19();
    return $serializer_instance_19;
  }
  function ProductMetrics_init_$Init$(seen1, quantity, unit, woodSpecies, species, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_21().u2v_1);
    }
    $this.w2v_1 = quantity;
    $this.x2v_1 = unit;
    $this.y2v_1 = woodSpecies;
    $this.z2v_1 = species;
    return $this;
  }
  function ProductMetrics_init_$Create$(seen1, quantity, unit, woodSpecies, species, serializationConstructorMarker) {
    return ProductMetrics_init_$Init$(seen1, quantity, unit, woodSpecies, species, serializationConstructorMarker, objectCreate(protoOf(ProductMetrics)));
  }
  function ProductMetrics() {
  }
  protoOf(ProductMetrics).r2v = function () {
    return this.w2v_1;
  };
  protoOf(ProductMetrics).a2b = function () {
    return this.x2v_1;
  };
  protoOf(ProductMetrics).g2p = function () {
    return this.y2v_1;
  };
  protoOf(ProductMetrics).s2v = function () {
    return this.z2v_1;
  };
  protoOf(ProductMetrics).toString = function () {
    return 'ProductMetrics(quantity=' + this.w2v_1 + ', unit=' + this.x2v_1 + ', woodSpecies=' + this.y2v_1 + ', species=' + this.z2v_1 + ')';
  };
  protoOf(ProductMetrics).hashCode = function () {
    var result = this.w2v_1 == null ? 0 : getNumberHashCode(this.w2v_1);
    result = imul(result, 31) + (this.x2v_1 == null ? 0 : getStringHashCode(this.x2v_1)) | 0;
    result = imul(result, 31) + (this.y2v_1 == null ? 0 : hashCode(this.y2v_1)) | 0;
    result = imul(result, 31) + (this.z2v_1 == null ? 0 : hashCode(this.z2v_1)) | 0;
    return result;
  };
  protoOf(ProductMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof ProductMetrics ? other : THROW_CCE();
    if (!equals(this.w2v_1, tmp0_other_with_cast.w2v_1))
      return false;
    if (!(this.x2v_1 == tmp0_other_with_cast.x2v_1))
      return false;
    if (!equals(this.y2v_1, tmp0_other_with_cast.y2v_1))
      return false;
    if (!equals(this.z2v_1, tmp0_other_with_cast.z2v_1))
      return false;
    return true;
  };
  function ProductModelDTO() {
  }
  function Companion_21() {
    Companion_instance_21 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c2w_1 = [null, Companion_getInstance().x14(), $serializer_init_$Create$(StringSerializer_getInstance()), null, null, null, null, null, null, null, null, null];
  }
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_21();
    return Companion_instance_21;
  }
  function $serializer_20() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.ProductModel', this, 12);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('ouvrage', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('destination', false);
    tmp0_serialDesc.ht('transformation', false);
    tmp0_serialDesc.ht('source', false);
    tmp0_serialDesc.ht('origin', false);
    tmp0_serialDesc.ht('volume', false);
    tmp0_serialDesc.ht('completion', false);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updatedDate', false);
    this.d2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).ii = function () {
    return this.d2w_1;
  };
  protoOf($serializer_20).wt = function () {
    var tmp0_cached = Companion_getInstance_21().c2w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], get_nullable(tmp0_cached[2]), StringSerializer_getInstance(), get_nullable($serializer_getInstance_17()), $serializer_getInstance_25(), get_nullable($serializer_getInstance_23()), get_nullable($serializer_getInstance_19()), $serializer_getInstance_0(), IntSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_20).ki = function (decoder) {
    var tmp0_desc = this.d2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = 0;
    var tmp14_local10 = new Long(0, 0);
    var tmp15_local11 = null;
    var tmp16_input = decoder.ul(tmp0_desc);
    var tmp17_cached = Companion_getInstance_21().c2w_1;
    if (tmp16_input.km()) {
      tmp4_local0 = tmp16_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.gm(tmp0_desc, 1, tmp17_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.im(tmp0_desc, 2, tmp17_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.em(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.im(tmp0_desc, 4, $serializer_getInstance_17(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.gm(tmp0_desc, 5, $serializer_getInstance_25(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.im(tmp0_desc, 6, $serializer_getInstance_23(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.im(tmp0_desc, 7, $serializer_getInstance_19(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.gm(tmp0_desc, 8, $serializer_getInstance_0(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.zl(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.am(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.im(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.gm(tmp0_desc, 1, tmp17_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.im(tmp0_desc, 2, tmp17_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.em(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.im(tmp0_desc, 4, $serializer_getInstance_17(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.gm(tmp0_desc, 5, $serializer_getInstance_25(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.im(tmp0_desc, 6, $serializer_getInstance_23(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.im(tmp0_desc, 7, $serializer_getInstance_19(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.gm(tmp0_desc, 8, $serializer_getInstance_0(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.zl(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.am(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.im(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.vl(tmp0_desc);
    return ProductModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  protoOf($serializer_20).e2w = function (encoder, value) {
    var tmp0_desc = this.d2w_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_21().c2w_1;
    tmp1_output.jn(tmp0_desc, 0, value.j2s_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.k2s_1);
    tmp1_output.nn(tmp0_desc, 2, tmp2_cached[2], value.l2s_1);
    tmp1_output.jn(tmp0_desc, 3, value.m2s_1);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_17(), value.n2s_1);
    tmp1_output.ln(tmp0_desc, 5, $serializer_getInstance_25(), value.o2s_1);
    tmp1_output.nn(tmp0_desc, 6, $serializer_getInstance_23(), value.p2s_1);
    tmp1_output.nn(tmp0_desc, 7, $serializer_getInstance_19(), value.q2s_1);
    tmp1_output.ln(tmp0_desc, 8, $serializer_getInstance_0(), value.r2s_1);
    tmp1_output.en(tmp0_desc, 9, value.s2s_1);
    tmp1_output.fn(tmp0_desc, 10, value.t2s_1);
    tmp1_output.nn(tmp0_desc, 11, LongSerializer_getInstance(), value.u2s_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_20).ji = function (encoder, value) {
    return this.e2w(encoder, value instanceof ProductModel ? value : THROW_CCE());
  };
  var $serializer_instance_20;
  function $serializer_getInstance_22() {
    if ($serializer_instance_20 == null)
      new $serializer_20();
    return $serializer_instance_20;
  }
  function ProductModel_init_$Init$(seen1, id, status, ouvrage, name, destination, transformation, source, origin, volume, completion, creationDate, updatedDate, serializationConstructorMarker, $this) {
    if (!(4095 === (4095 & seen1))) {
      throwMissingFieldException(seen1, 4095, $serializer_getInstance_22().d2w_1);
    }
    $this.j2s_1 = id;
    $this.k2s_1 = status;
    $this.l2s_1 = ouvrage;
    $this.m2s_1 = name;
    $this.n2s_1 = destination;
    $this.o2s_1 = transformation;
    $this.p2s_1 = source;
    $this.q2s_1 = origin;
    $this.r2s_1 = volume;
    $this.s2s_1 = completion;
    $this.t2s_1 = creationDate;
    $this.u2s_1 = updatedDate;
    return $this;
  }
  function ProductModel_init_$Create$(seen1, id, status, ouvrage, name, destination, transformation, source, origin, volume, completion, creationDate, updatedDate, serializationConstructorMarker) {
    return ProductModel_init_$Init$(seen1, id, status, ouvrage, name, destination, transformation, source, origin, volume, completion, creationDate, updatedDate, serializationConstructorMarker, objectCreate(protoOf(ProductModel)));
  }
  function ProductModel() {
  }
  protoOf(ProductModel).k1y = function () {
    return this.j2s_1;
  };
  protoOf(ProductModel).y2f = function () {
    return this.k2s_1;
  };
  protoOf(ProductModel).v2q = function () {
    return this.l2s_1;
  };
  protoOf(ProductModel).h9 = function () {
    return this.m2s_1;
  };
  protoOf(ProductModel).y2q = function () {
    return this.n2s_1;
  };
  protoOf(ProductModel).x2q = function () {
    return this.o2s_1;
  };
  protoOf(ProductModel).s1c = function () {
    return this.p2s_1;
  };
  protoOf(ProductModel).i23 = function () {
    return this.q2s_1;
  };
  protoOf(ProductModel).a2w = function () {
    return this.r2s_1;
  };
  protoOf(ProductModel).b2w = function () {
    return this.s2s_1;
  };
  protoOf(ProductModel).v2h = function () {
    return this.t2s_1;
  };
  protoOf(ProductModel).w2h = function () {
    return this.u2s_1;
  };
  protoOf(ProductModel).s2State = function () {
    return this.k2s_1;
  };
  protoOf(ProductModel).s2Id = function () {
    return this.j2s_1;
  };
  protoOf(ProductModel).toString = function () {
    return 'ProductModel(id=' + this.j2s_1 + ', status=' + this.k2s_1 + ', ouvrage=' + this.l2s_1 + ', name=' + this.m2s_1 + ', destination=' + this.n2s_1 + ', transformation=' + this.o2s_1 + ', source=' + this.p2s_1 + ', origin=' + this.q2s_1 + ', volume=' + this.r2s_1 + ', completion=' + this.s2s_1 + ', creationDate=' + this.t2s_1.toString() + ', updatedDate=' + toString(this.u2s_1) + ')';
  };
  protoOf(ProductModel).hashCode = function () {
    var result = getStringHashCode(this.j2s_1);
    result = imul(result, 31) + this.k2s_1.hashCode() | 0;
    result = imul(result, 31) + (this.l2s_1 == null ? 0 : hashCode(this.l2s_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2s_1) | 0;
    result = imul(result, 31) + (this.n2s_1 == null ? 0 : this.n2s_1.hashCode()) | 0;
    result = imul(result, 31) + this.o2s_1.hashCode() | 0;
    result = imul(result, 31) + (this.p2s_1 == null ? 0 : this.p2s_1.hashCode()) | 0;
    result = imul(result, 31) + (this.q2s_1 == null ? 0 : hashCode(this.q2s_1)) | 0;
    result = imul(result, 31) + this.r2s_1.hashCode() | 0;
    result = imul(result, 31) + this.s2s_1 | 0;
    result = imul(result, 31) + this.t2s_1.hashCode() | 0;
    result = imul(result, 31) + (this.u2s_1 == null ? 0 : this.u2s_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProductModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductModel))
      return false;
    var tmp0_other_with_cast = other instanceof ProductModel ? other : THROW_CCE();
    if (!(this.j2s_1 === tmp0_other_with_cast.j2s_1))
      return false;
    if (!this.k2s_1.equals(tmp0_other_with_cast.k2s_1))
      return false;
    if (!equals(this.l2s_1, tmp0_other_with_cast.l2s_1))
      return false;
    if (!(this.m2s_1 === tmp0_other_with_cast.m2s_1))
      return false;
    if (!equals(this.n2s_1, tmp0_other_with_cast.n2s_1))
      return false;
    if (!this.o2s_1.equals(tmp0_other_with_cast.o2s_1))
      return false;
    if (!equals(this.p2s_1, tmp0_other_with_cast.p2s_1))
      return false;
    if (!equals(this.q2s_1, tmp0_other_with_cast.q2s_1))
      return false;
    if (!this.r2s_1.equals(tmp0_other_with_cast.r2s_1))
      return false;
    if (!(this.s2s_1 === tmp0_other_with_cast.s2s_1))
      return false;
    if (!this.t2s_1.equals(tmp0_other_with_cast.t2s_1))
      return false;
    if (!equals(this.u2s_1, tmp0_other_with_cast.u2s_1))
      return false;
    return true;
  };
  function ProductRefDTO() {
  }
  function SourceModelDTO() {
  }
  function RawProductModelDTO() {
  }
  function Companion_22() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2w_1 = [new ArrayListSerializer($serializer_getInstance_24())];
  }
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_22();
    return Companion_instance_22;
  }
  function $serializer_21() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.SourceModel', this, 1);
    tmp0_serialDesc.ht('row', false);
    this.i2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_21).ii = function () {
    return this.i2w_1;
  };
  protoOf($serializer_21).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_22().h2w_1[0]];
  };
  protoOf($serializer_21).ki = function (decoder) {
    var tmp0_desc = this.i2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    var tmp6_cached = Companion_getInstance_22().h2w_1;
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return SourceModel_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_21).j2w = function (encoder, value) {
    var tmp0_desc = this.i2w_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_22().h2w_1;
    tmp1_output.ln(tmp0_desc, 0, tmp2_cached[0], value.k2w_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_21).ji = function (encoder, value) {
    return this.j2w(encoder, value instanceof SourceModel ? value : THROW_CCE());
  };
  var $serializer_instance_21;
  function $serializer_getInstance_23() {
    if ($serializer_instance_21 == null)
      new $serializer_21();
    return $serializer_instance_21;
  }
  function SourceModel_init_$Init$(seen1, row, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_23().i2w_1);
    }
    $this.k2w_1 = row;
    return $this;
  }
  function SourceModel_init_$Create$(seen1, row, serializationConstructorMarker) {
    return SourceModel_init_$Init$(seen1, row, serializationConstructorMarker, objectCreate(protoOf(SourceModel)));
  }
  function SourceModel() {
  }
  protoOf(SourceModel).f2w = function () {
    return this.k2w_1;
  };
  protoOf(SourceModel).toString = function () {
    return 'SourceModel(row=' + this.k2w_1 + ')';
  };
  protoOf(SourceModel).hashCode = function () {
    return hashCode(this.k2w_1);
  };
  protoOf(SourceModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SourceModel))
      return false;
    var tmp0_other_with_cast = other instanceof SourceModel ? other : THROW_CCE();
    if (!equals(this.k2w_1, tmp0_other_with_cast.k2w_1))
      return false;
    return true;
  };
  function Companion_23() {
    Companion_instance_23 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l2w_1 = [$serializer_init_$Create$(StringSerializer_getInstance()), $serializer_init_$Create$(StringSerializer_getInstance()), null, $serializer_init_$Create$(StringSerializer_getInstance())];
  }
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_23();
    return Companion_instance_23;
  }
  function $serializer_22() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.RawProductModel', this, 4);
    tmp0_serialDesc.ht('provider', false);
    tmp0_serialDesc.ht('productType', false);
    tmp0_serialDesc.ht('metrics', false);
    tmp0_serialDesc.ht('product', true);
    this.m2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_22).ii = function () {
    return this.m2w_1;
  };
  protoOf($serializer_22).wt = function () {
    var tmp0_cached = Companion_getInstance_23().l2w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable($serializer_getInstance_21()), get_nullable(tmp0_cached[3])];
  };
  protoOf($serializer_22).ki = function (decoder) {
    var tmp0_desc = this.m2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    var tmp9_cached = Companion_getInstance_23().l2w_1;
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.im(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.im(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance_21(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.im(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.im(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance_21(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return RawProductModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_22).n2w = function (encoder, value) {
    var tmp0_desc = this.m2w_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_23().l2w_1;
    tmp1_output.nn(tmp0_desc, 0, tmp2_cached[0], value.o2w_1);
    tmp1_output.nn(tmp0_desc, 1, tmp2_cached[1], value.p2w_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance_21(), value.q2w_1);
    if (tmp1_output.rn(tmp0_desc, 3) ? true : !(value.r2w_1 == null)) {
      tmp1_output.nn(tmp0_desc, 3, tmp2_cached[3], value.r2w_1);
    }
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_22).ji = function (encoder, value) {
    return this.n2w(encoder, value instanceof RawProductModel ? value : THROW_CCE());
  };
  var $serializer_instance_22;
  function $serializer_getInstance_24() {
    if ($serializer_instance_22 == null)
      new $serializer_22();
    return $serializer_instance_22;
  }
  function RawProductModel_init_$Init$(seen1, provider, productType, metrics, product, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_24().m2w_1);
    }
    $this.o2w_1 = provider;
    $this.p2w_1 = productType;
    $this.q2w_1 = metrics;
    if (0 === (seen1 & 8))
      $this.r2w_1 = null;
    else
      $this.r2w_1 = product;
    return $this;
  }
  function RawProductModel_init_$Create$(seen1, provider, productType, metrics, product, serializationConstructorMarker) {
    return RawProductModel_init_$Init$(seen1, provider, productType, metrics, product, serializationConstructorMarker, objectCreate(protoOf(RawProductModel)));
  }
  function RawProductModel() {
  }
  protoOf(RawProductModel).g2w = function () {
    return this.o2w_1;
  };
  protoOf(RawProductModel).u2q = function () {
    return this.p2w_1;
  };
  protoOf(RawProductModel).s2u = function () {
    return this.q2w_1;
  };
  protoOf(RawProductModel).q2u = function () {
    return this.r2w_1;
  };
  protoOf(RawProductModel).toString = function () {
    return 'RawProductModel(provider=' + this.o2w_1 + ', productType=' + this.p2w_1 + ', metrics=' + this.q2w_1 + ', product=' + this.r2w_1 + ')';
  };
  protoOf(RawProductModel).hashCode = function () {
    var result = this.o2w_1 == null ? 0 : hashCode(this.o2w_1);
    result = imul(result, 31) + (this.p2w_1 == null ? 0 : hashCode(this.p2w_1)) | 0;
    result = imul(result, 31) + (this.q2w_1 == null ? 0 : this.q2w_1.hashCode()) | 0;
    result = imul(result, 31) + (this.r2w_1 == null ? 0 : hashCode(this.r2w_1)) | 0;
    return result;
  };
  protoOf(RawProductModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RawProductModel))
      return false;
    var tmp0_other_with_cast = other instanceof RawProductModel ? other : THROW_CCE();
    if (!equals(this.o2w_1, tmp0_other_with_cast.o2w_1))
      return false;
    if (!equals(this.p2w_1, tmp0_other_with_cast.p2w_1))
      return false;
    if (!equals(this.q2w_1, tmp0_other_with_cast.q2w_1))
      return false;
    if (!equals(this.r2w_1, tmp0_other_with_cast.r2w_1))
      return false;
    return true;
  };
  function TransformationModelDTO() {
  }
  function $serializer_23() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.product.domain.model.TransformationModel', this, 2);
    tmp0_serialDesc.ht('actor', false);
    tmp0_serialDesc.ht('date', true);
    this.s2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_23).ii = function () {
    return this.s2w_1;
  };
  protoOf($serializer_23).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_23).ki = function (decoder) {
    var tmp0_desc = this.s2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return TransformationModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_23).t2w = function (encoder, value) {
    var tmp0_desc = this.s2w_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance(), value.u2w_1);
    if (tmp1_output.rn(tmp0_desc, 1) ? true : !(value.v2w_1 == null)) {
      tmp1_output.nn(tmp0_desc, 1, LongSerializer_getInstance(), value.v2w_1);
    }
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_23).ji = function (encoder, value) {
    return this.t2w(encoder, value instanceof TransformationModel ? value : THROW_CCE());
  };
  var $serializer_instance_23;
  function $serializer_getInstance_25() {
    if ($serializer_instance_23 == null)
      new $serializer_23();
    return $serializer_instance_23;
  }
  function TransformationModel_init_$Init$(seen1, actor, date, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_25().s2w_1);
    }
    $this.u2w_1 = actor;
    if (0 === (seen1 & 2))
      $this.v2w_1 = null;
    else
      $this.v2w_1 = date;
    return $this;
  }
  function TransformationModel_init_$Create$(seen1, actor, date, serializationConstructorMarker) {
    return TransformationModel_init_$Init$(seen1, actor, date, serializationConstructorMarker, objectCreate(protoOf(TransformationModel)));
  }
  function TransformationModel() {
  }
  protoOf(TransformationModel).t2q = function () {
    return this.u2w_1;
  };
  protoOf(TransformationModel).x25 = function () {
    return this.v2w_1;
  };
  protoOf(TransformationModel).toString = function () {
    return 'TransformationModel(actor=' + this.u2w_1 + ', date=' + toString(this.v2w_1) + ')';
  };
  protoOf(TransformationModel).hashCode = function () {
    var result = this.u2w_1.hashCode();
    result = imul(result, 31) + (this.v2w_1 == null ? 0 : this.v2w_1.hashCode()) | 0;
    return result;
  };
  protoOf(TransformationModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformationModel))
      return false;
    var tmp0_other_with_cast = other instanceof TransformationModel ? other : THROW_CCE();
    if (!this.u2w_1.equals(tmp0_other_with_cast.u2w_1))
      return false;
    if (!equals(this.v2w_1, tmp0_other_with_cast.v2w_1))
      return false;
    return true;
  };
  function ProductModelAllQueryDTO() {
  }
  function ProductModelAllResponseDTO() {
  }
  function ProductModelGetQueryDTO() {
  }
  function ProductModelGetResponseDTO() {
  }
  function ProductPageQueryFiltersDTO() {
  }
  function ProductModelPageQueryDTO() {
  }
  function ProductPageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(ProductState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(ProductState), 'name', protoOf(ProductState).h9);
  defineProp(protoOf(ProductState), 'ordinal', protoOf(ProductState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTransformationDateChangeCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTransformationDateChangeCommand), 'date', function () {
    return this.x25();
  });
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTransformationDateChangedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTransformationDateChangedEvent), 'transformationDate', function () {
    return this.l2q();
  });
  defineProp(protoOf(ProductTransformationDateChangedEvent), 'time');
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(ProductCreateCommand), 'actor', function () {
    return this.t2q();
  });
  defineProp(protoOf(ProductCreateCommand), 'productType', function () {
    return this.u2q();
  });
  defineProp(protoOf(ProductCreateCommand), 'ouvrage', function () {
    return this.v2q();
  });
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(ProductCreatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductCreatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductCreatedEvent), 'ouvrageId', function () {
    return this.w2q();
  });
  defineProp(protoOf(ProductCreatedEvent), 'transformation', function () {
    return this.x2q();
  });
  defineProp(protoOf(ProductCreatedEvent), 'destination', function () {
    return this.y2q();
  });
  defineProp(protoOf(ProductCreatedEvent), 'time');
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(ProductDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(ProductDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductDeletedEvent), 'time');
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(ProductFinishCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(ProductFinishedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductFinishedEvent), 'time');
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(ProductImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(ProductImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(ProductImportedEvent), 'time');
  protoOf($serializer_9).xt = typeParametersSerializers;
  defineProp(protoOf(ProductInitLinkedCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductInitLinkedCommand), 'ouvrageId', function () {
    return this.w2q();
  });
  defineProp(protoOf(ProductInitLinkedCommand), 'actor', function () {
    return this.t2q();
  });
  defineProp(protoOf(ProductInitLinkedCommand), 'destination', function () {
    return this.y2q();
  });
  defineProp(protoOf(ProductRenameCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductRenameCommand), 'name', function () {
    return this.h9();
  });
  protoOf($serializer_10).xt = typeParametersSerializers;
  defineProp(protoOf(ProductRenamedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductRenamedEvent), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(ProductRenamedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductRenamedEvent), 'time');
  defineProp(protoOf(ProductTransformationActorDefineCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTransformationActorDefineCommand), 'actor', function () {
    return this.t2q();
  });
  protoOf($serializer_11).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTransformationActorDefinedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTransformationActorDefinedEvent), 'actor', function () {
    return this.t2q();
  });
  defineProp(protoOf(ProductTransformationActorDefinedEvent), 'time');
  protoOf($serializer_12).xt = typeParametersSerializers;
  defineProp(protoOf(ProductUnlockCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_13).xt = typeParametersSerializers;
  defineProp(protoOf(ProductUnlockedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductUnlockedEvent), 'time');
  defineProp(protoOf(ProductUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductUpdateCommand), 'ouvrage', function () {
    return this.v2q();
  });
  defineProp(protoOf(ProductUpdateCommand), 'source', function () {
    return this.s1c();
  });
  defineProp(protoOf(ProductUpdateCommand), 'destination', function () {
    return this.y2q();
  });
  defineProp(protoOf(ProductUpdateCommand), 'origin', function () {
    return this.i23();
  });
  protoOf($serializer_14).xt = typeParametersSerializers;
  defineProp(protoOf(ProductUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductUpdatedEvent), 'ouvrage', function () {
    return this.v2q();
  });
  defineProp(protoOf(ProductUpdatedEvent), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(ProductUpdatedEvent), 'source', function () {
    return this.s1c();
  });
  defineProp(protoOf(ProductUpdatedEvent), 'destination', function () {
    return this.y2q();
  });
  defineProp(protoOf(ProductUpdatedEvent), 'origin', function () {
    return this.i23();
  });
  defineProp(protoOf(ProductUpdatedEvent), 'time');
  protoOf($serializer_15).xt = typeParametersSerializers;
  defineProp(protoOf(DestinationModel), 'client', function () {
    return this.o2u();
  });
  defineProp(protoOf(DestinationModel), 'endProduct', function () {
    return this.p2u();
  });
  protoOf($serializer_16).xt = typeParametersSerializers;
  defineProp(protoOf(EndProductModel), 'product', function () {
    return this.q2u();
  });
  defineProp(protoOf(EndProductModel), 'productType', function () {
    return this.u2q();
  });
  defineProp(protoOf(EndProductModel), 'productTypes', function () {
    return this.r2u();
  });
  defineProp(protoOf(EndProductModel), 'metrics', function () {
    return this.s2u();
  });
  protoOf($serializer_17).xt = typeParametersSerializers;
  defineProp(protoOf(OriginModel), 'zones', function () {
    return this.f2v();
  });
  protoOf($serializer_18).xt = typeParametersSerializers;
  defineProp(protoOf(OriginZoneModel), 'removalZone', function () {
    return this.g2v();
  });
  defineProp(protoOf(OriginZoneModel), 'metrics', function () {
    return this.s2u();
  });
  defineProp(protoOf(OriginZoneModel), 'type', function () {
    return this.j21();
  });
  protoOf($serializer_19).xt = typeParametersSerializers;
  defineProp(protoOf(ProductMetrics), 'quantity', function () {
    return this.r2v();
  });
  defineProp(protoOf(ProductMetrics), 'unit', function () {
    return this.a2b();
  });
  defineProp(protoOf(ProductMetrics), 'woodSpecies', function () {
    return this.g2p();
  });
  defineProp(protoOf(ProductMetrics), 'species', function () {
    return this.s2v();
  });
  protoOf($serializer_20).xt = typeParametersSerializers;
  defineProp(protoOf(ProductModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(ProductModel), 'ouvrage', function () {
    return this.v2q();
  });
  defineProp(protoOf(ProductModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductModel), 'destination', function () {
    return this.y2q();
  });
  defineProp(protoOf(ProductModel), 'transformation', function () {
    return this.x2q();
  });
  defineProp(protoOf(ProductModel), 'source', function () {
    return this.s1c();
  });
  defineProp(protoOf(ProductModel), 'origin', function () {
    return this.i23();
  });
  defineProp(protoOf(ProductModel), 'volume', function () {
    return this.a2w();
  });
  defineProp(protoOf(ProductModel), 'completion', function () {
    return this.b2w();
  });
  defineProp(protoOf(ProductModel), 'creationDate', function () {
    return this.v2h();
  });
  defineProp(protoOf(ProductModel), 'updatedDate', function () {
    return this.w2h();
  });
  protoOf($serializer_21).xt = typeParametersSerializers;
  defineProp(protoOf(SourceModel), 'row', function () {
    return this.f2w();
  });
  protoOf($serializer_22).xt = typeParametersSerializers;
  defineProp(protoOf(RawProductModel), 'provider', function () {
    return this.g2w();
  });
  defineProp(protoOf(RawProductModel), 'productType', function () {
    return this.u2q();
  });
  defineProp(protoOf(RawProductModel), 'metrics', function () {
    return this.s2u();
  });
  defineProp(protoOf(RawProductModel), 'product', function () {
    return this.q2u();
  });
  protoOf($serializer_23).xt = typeParametersSerializers;
  defineProp(protoOf(TransformationModel), 'actor', function () {
    return this.t2q();
  });
  defineProp(protoOf(TransformationModel), 'date', function () {
    return this.x25();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  Companion_instance_9 = new Companion_9();
  Companion_instance_12 = new Companion_12();
  Companion_instance_13 = new Companion_13();
  Companion_instance_14 = new Companion_14();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$automate = $org$boislocal$platform$s2$product$domain.automate || ($org$boislocal$platform$s2$product$domain.automate = {});
    $org$boislocal$platform$s2$product$domain$automate.ProductState = ProductState;
    $org$boislocal$platform$s2$product$domain$automate.ProductState.values = values;
    $org$boislocal$platform$s2$product$domain$automate.ProductState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$product$domain$automate.ProductState, 'Exists', ProductState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$product$domain$automate.ProductState, 'Deleted', ProductState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$product$domain$automate.ProductState, 'Finished', ProductState_Finished_getInstance);
    defineProp($org$boislocal$platform$s2$product$domain$automate.ProductState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$command = $org$boislocal$platform$s2$product$domain.command || ($org$boislocal$platform$s2$product$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$model = $org$boislocal$platform$s2$product$domain.model || ($org$boislocal$platform$s2$product$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$model = $org$boislocal$platform$s2$product$domain.model || ($org$boislocal$platform$s2$product$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$model = $org$boislocal$platform$s2$product$domain.model || ($org$boislocal$platform$s2$product$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$model = $org$boislocal$platform$s2$product$domain.model || ($org$boislocal$platform$s2$product$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$model = $org$boislocal$platform$s2$product$domain.model || ($org$boislocal$platform$s2$product$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$model = $org$boislocal$platform$s2$product$domain.model || ($org$boislocal$platform$s2$product$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$model = $org$boislocal$platform$s2$product$domain.model || ($org$boislocal$platform$s2$product$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$query = $org$boislocal$platform$s2$product$domain.query || ($org$boislocal$platform$s2$product$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$query = $org$boislocal$platform$s2$product$domain.query || ($org$boislocal$platform$s2$product$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$product = $org$boislocal$platform$s2.product || ($org$boislocal$platform$s2.product = {});
    var $org$boislocal$platform$s2$product$domain = $org$boislocal$platform$s2$product.domain || ($org$boislocal$platform$s2$product.domain = {});
    var $org$boislocal$platform$s2$product$domain$query = $org$boislocal$platform$s2$product$domain.query || ($org$boislocal$platform$s2$product$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = S2_getInstance;
  _.$_$.b = $serializer_getInstance_22;
  _.$_$.c = ProductDeleteCommand;
  _.$_$.d = ProductFinishCommand;
  _.$_$.e = ProductInitLinkedCommand;
  _.$_$.f = ProductRenameCommand;
  _.$_$.g = ProductTransformationActorDefineCommand;
  _.$_$.h = ProductTransformationDateChangeCommand;
  _.$_$.i = ProductUnlockCommand;
  _.$_$.j = ProductUpdateCommand;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-product-product-domain.js.map
